// import * as React from "react";
// import Grid from "@mui/material/Grid";
// import List from "@mui/material/List";
// import Card from "@mui/material/Card";
// import CardHeader from "@mui/material/CardHeader";
// import ListItem from "@mui/material/ListItem";
// import ListItemText from "@mui/material/ListItemText";
// import ListItemIcon from "@mui/material/ListItemIcon";
// import Checkbox from "@mui/material/Checkbox";
// import Button from "@mui/material/Button";
// import Divider from "@mui/material/Divider";
// import { InputAdornment, Skeleton, TextField } from "@mui/material";
// import { common_axios } from "../../../../App";
// import { toast } from "react-toastify";
// import { useState, memo } from "react";
// import { useAsyncDebounce } from "react-table";
// import SearchIcon from "@mui/icons-material/Search";
// import { useEffect } from "react";
// import { useSelector } from "react-redux";
// import Swal from "sweetalert2";
// const customId1 = "custom-id-yess";

// function not(a, b) {
//   return a.filter((value) => {
//     return b?.indexOf(value) === -1;
//   });
// }

// function intersection(a, b) {
//   return a.filter((value) => b?.indexOf(value) !== -1);
// }

// function union(a, b) {
//   return [...a, ...not(b, a)];
// }

// function TransferListTest({ onData, width, height, rightData, pageType, resetState }) {
//   // const [permanentData, setPermanentData] = useState([]);

//   const [checked, setChecked] = useState([]);
//   const [left, setLeft] = useState([]);
//   const [right, setRight] = useState([]);
//   const [right1, setRight1] = useState([]);
//   const [right2, setRight2] = useState([]);
//   const [data1, setData1] = useState([]);
//   const [data2, setData2] = useState([]);
//   const [hideSkeleton, setHideSkeleton] = useState(false);
//   const [paginationState, setPaginationState] = useState({
//     pageNumber: 0,
//     pageSize: 10,
//     searchValue: "",
//     searchValue1: "",
//     buttonLeftToRight: false,
//     rightPageNumber: 0,
//     rightPageSize: 10,
//     rightPageStartIndex: 0,
//     rightPageEndIndex: 10,
//     rightsideAddedData: null,
//     leftsideAddedData: null,
//     rightSideSendData: null,
//     leftSideSendData: null,
//   });

//   const ResetStates = () => {
//     setChecked([]);
//     setLeft([]);
//     setRight([]);
//     setRight1([]);
//     setRight2([]);
//     setData1([]);
//     setData2([]);
//     setPaginationState({
//       pageNumber: 0,
//       pageSize: 10,
//       searchValue: "",
//       searchValue1: "",
//       buttonLeftToRight: false,
//       rightPageNumber: 0,
//       rightPageSize: 10,
//       rightPageStartIndex: 0,
//       rightPageEndIndex: 10,
//       rightsideAddedData: null,
//       leftsideAddedData: null,
//     });
//   };

//   const reloadReducer = useSelector((state) => state?.relodReducer?.relodState);

//   const leftChecked = intersection(checked, left);
//   const rightChecked = intersection(checked, right);

//   const handleToggle = (value) => () => {
//     const currentIndex = checked?.indexOf(value);
//     const newChecked = [...checked];

//     if (currentIndex === -1) {
//       newChecked.push(value);
//     } else {
//       newChecked?.splice(currentIndex, 1);
//     }

//     setChecked(newChecked);
//   };
//   const onChange = useAsyncDebounce((value) => {
//     setPaginationState({
//       ...paginationState,
//       searchValue: value,
//     });
//   }, 1000);
//   const numberOfChecked = (items) => intersection(checked, items)?.length;

//   const handleToggleAll = (items) => () => {
//     if (numberOfChecked(items) === items?.length) {
//       setChecked(not(checked, items));
//     } else {
//       setChecked(union(checked, items));
//     }
//   };

//   const handleCheckedRight = () => {
//     // for (let index1 = 0; index1 < data2?.content?.length; index1++) {
//     //     const element1 = data2?.content?.[index1];
//     // }

//     // for (let index = 0; index < data1?.content?.length; index++) {
//     //     const element = data1?.content?.[index];

//     //         for (let index2 = 0; index2 < leftChecked?.length; index2++) {
//     //             const element2 = leftChecked?.[index2];

//     //         }

//     // }
//     setRight(right.concat(leftChecked));
//     setRight1(right.concat(leftChecked));
//     setLeft(not(left, leftChecked));
//     setChecked(not(checked, leftChecked));
//     let objj = paginationState.leftsideAddedData;
//     let objjj1 = paginationState.leftSideSendData
//       ? JSON.parse(JSON.stringify(paginationState.leftSideSendData))
//       : null;
//     let result2 = [];
//     let result3 = [];

//     // console.log({ objj }, paginationState.leftSideSendData);

//     if (objj) {
//       Object.keys(paginationState.leftsideAddedData)?.forEach(
//         (element, index) => {
//           paginationState.leftsideAddedData?.[element]?.forEach(
//             (ele, indexx) => {
//               leftChecked?.forEach((element1, ind) => {
//                 if (element1.id == ele.id) {
//                   objj?.[element]?.splice(
//                     indexx,
//                     leftChecked.length > 0 ? leftChecked.length : 1
//                   );
//                 }
//               });
//             }
//           );
//         }
//       );
//     }

//     if (objjj1) {
//       Object.keys(paginationState.leftSideSendData)?.forEach(
//         (element, index) => {
//           paginationState.leftSideSendData?.[element]?.forEach(
//             (ele, indexx) => {
//               leftChecked?.forEach((element1, ind) => {
//                 if (element1.id == ele.id) {
//                   // alert("here");
//                   objjj1?.[element]?.splice(
//                     objjj1?.[element]?.findIndex((i) => i.id === element1.id),
//                     1
//                   );
//                 }
//               });
//             }
//           );
//         }
//       );
//     }

//     // console.log("YYYYYYYYY", { objjj1 });

//     leftChecked?.forEach((obj1) => {
//       let found = false;

//       data1?.content?.forEach((obj2) => {
//         if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
//           found = true;
//         }
//       });

//       if (found) {
//         result2.push(obj1);
//       }
//     });

//     leftChecked?.forEach((obj1) => {
//       let found = false;

//       data2?.content?.forEach((obj2) => {
//         if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
//           found = true;
//         }
//       });

//       if (found) {
//         result3.push(obj1);
//       }
//     });

//     // console.log(
//     //   { objj, result2, leftChecked, result3 },
//     //   data1?.content,
//     //   paginationState.leftsideAddedData,
//     //   paginationState.leftSideSendData
//     // );

//     // let objj1 = paginationState.leftSideSendData;
//     // let objj2 = paginationState.leftSideSendData;

//     // let resultLast1 = [];
//     // let resultLast = [];
//     // let obbbj = {};
//     // Object.keys(objj2)?.forEach((element, index) => {
//     //   console.log("first0");

//     //   objj2?.[element]?.forEach((ele, indexx) => {
//     //     console.log("first1");
//     //     leftChecked?.forEach(async (element1, ind) => {
//     //       console.log("first", element1, ele);
//     //       if (paginationState.pageNumber != element) {
//     //         console.log("second");
//     //         if (element1.id == ele.id) {
//     //           if (!obbbj?.[index]) {
//     //             obbbj[index] = 0;
//     //           }

//     //           console.log(
//     //             "third",
//     //             { element1, ele, indexx, objj1, obbbj },
//     //             objj1?.[element]?.findIndex((i) => i.id === element1.id)
//     //           );
//     //           await objj1?.[element]?.splice(
//     //             // indexx - obbbj[index],
//     //             objj1?.[element]?.findIndex((i) => i.id === element1.id),
//     //             1
//     //             //   leftChecked.length > 0 ? leftChecked.length : 1
//     //           );
//     //           obbbj[index] = obbbj[index] + 1;
//     //         }
//     //       } else if (paginationState.pageNumber == element) {
//     //         console.log("second1");
//     //         const result1 = [];
//     //         const result2 = [];
//     //         objj1?.[element]?.forEach(async (obj1) => {
//     //           let found = false;

//     //           leftChecked?.forEach(async (obj2) => {
//     //             if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
//     //               found = true;
//     //             }
//     //           });
//     //           // data2?.content?.forEach(async (obj2) => {
//     //           //   if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
//     //           //     found = true;
//     //           //   }
//     //           // });

//     //           if (!found) {
//     //             console.log("HHHHHHH", objj1?.[element]);
//     //             //   alert("here");
//     //             objj1?.[element]?.splice(
//     //               // indexx - obbbj[index],
//     //               objj1?.[element]?.findIndex((i) => i.id === element1.id),
//     //               1
//     //               //   leftChecked.length > 0 ? leftChecked.length : 1
//     //             );
//     //             result1.push(obj1);
//     //           }
//     //         });

//     //         leftChecked?.forEach((obj1) => {
//     //           let found = false;

//     //           data2?.content?.forEach((obj2) => {
//     //             if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
//     //               found = true;
//     //             }
//     //           });

//     //           if (found) {
//     //             result2.push(obj1);
//     //           }
//     //         });

//     //         if (leftChecked?.length - 1 == ind) {
//     //           resultLast = result1;
//     //           resultLast1 = result2;
//     //         }

//     //         console.log("UUUUUUU", result1, result2);
//     //       }
//     //     });
//     //   });
//     // });

//     let vall = {
//       ...paginationState.rightSideSendData,
//       [paginationState.pageNumber]: paginationState.rightSideSendData?.[
//         paginationState.pageNumber
//       ]
//         ? [
//             ...paginationState.rightSideSendData?.[paginationState.pageNumber],
//             ...leftChecked,
//           ]
//         : leftChecked,
//     };

//     localStorage.setItem("phonebookrightSideSendData", JSON.stringify(vall));
//     // localStorage.setItem("phonebookrightSideSendData", JSON.stringify(objjj1));

//     setPaginationState({
//       ...paginationState,
//       buttonLeftToRight: true,
//       //   leftsideAddedData: {
//       //     ...paginationState.leftsideAddedData,
//       //     [paginationState.pageNumber]: leftChecked,
//       //   },
//       rightsideAddedData: {
//         ...paginationState.rightsideAddedData,
//         [paginationState.rightPageNumber]: paginationState.rightsideAddedData?.[
//           paginationState.rightPageNumber
//         ]
//           ? [
//               ...paginationState.rightsideAddedData?.[
//                 paginationState.rightPageNumber
//               ],
//               ...leftChecked,
//             ]
//           : leftChecked,
//       },
//       rightSideSendData: {
//         ...paginationState.rightSideSendData,
//         [paginationState.pageNumber]: paginationState.rightSideSendData?.[
//           paginationState.pageNumber
//         ]
//           ? [
//               ...paginationState.rightSideSendData?.[
//                 paginationState.pageNumber
//               ],
//               ...result2,
//             ]
//           : result2,
//       },
//       leftsideAddedData: objj,
//       leftSideSendData: objjj1,
//     });

//     // const result1 = [];
//     // leftChecked?.forEach((obj1) => {
//     //   let found = false;

//     //   data2?.content?.forEach((obj2) => {
//     //     if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
//     //       found = true;
//     //     }
//     //   });

//     //   if (!found) {
//     //     result1.push(obj1);
//     //   }
//     // });

//     // paginationState.leftsideAddedData?.[0]?.forEach((ele, indexx) => {
//     //     leftChecked?.forEach((element1, ind) => {
//     //       if (element1.id == ele.id) {
//     //         objj?.[0]?.splice(
//     //           indexx,
//     //           leftChecked.length > 0 ? leftChecked.length : 1
//     //         );
//     //       }
//     //     });
//     //   });

//     // paginationState.leftsideAddedData?.[0]?.forEach((ele, indexx) => {
//     //   result1?.forEach((element1, ind) => {
//     //     if (element1.id == ele.id) {
//     //       objj?.[0]?.splice(indexx, result1.length > 0 ? result1.length : 1);
//     //     }
//     //   });
//     // });

//     // setPaginationState({
//     //   ...paginationState,
//     //   buttonLeftToRight: true,
//     //   //   leftsideAddedData: {
//     //   //     ...paginationState.leftsideAddedData,
//     //   //     [paginationState.pageNumber]: leftChecked,
//     //   //   },
//     //   rightsideAddedData: {
//     //     ...paginationState.rightsideAddedData,
//     //     [0]: paginationState.rightsideAddedData?.[0]
//     //       ? [...paginationState.rightsideAddedData?.[0], ...leftChecked]
//     //       : leftChecked,
//     //   },
//     //   leftsideAddedData: objj,
//     // });
//   };

//   const handleCheckedLeft = () => {
//     setLeft(left.concat(rightChecked));
//     setRight(not(right, rightChecked));
//     setRight1(not(right, rightChecked));
//     setChecked(not(checked, rightChecked));
//     let objj = paginationState.rightsideAddedData;
//     if (objj) {
//       Object.keys(paginationState.rightsideAddedData)?.forEach(
//         (element, index) => {
//           paginationState.rightsideAddedData?.[element]?.forEach(
//             (ele, indexx) => {
//               rightChecked?.forEach((element1, ind) => {
//                 if (element1.id == ele.id) {
//                   objj?.[element]?.splice(
//                     indexx,
//                     rightChecked.length > 0 ? rightChecked.length : 1
//                   );
//                 }
//               });
//             }
//           );
//         }
//       );
//     }

//     // let objj1 = JSON.parse(localStorage.getItem("phonebookrightSideSendData"));
//     // let objj2 = JSON.parse(localStorage.getItem("phonebookrightSideSendData"));
//     // let objj1 =
//     //   paginationState.rightSideSendData?.[paginationState.pageNumber]?.length >
//     //   0
//     //     ? JSON.parse(JSON.stringify(paginationState.rightSideSendData))
//     //     : null;
//     // let objj2 =
//     //   paginationState.rightSideSendData?.[paginationState.pageNumber]?.length >
//     //   0
//     //     ? JSON.parse(JSON.stringify(paginationState.rightSideSendData))
//     //     : null;

//     let obr = {};
//     if (paginationState.rightSideSendData) {
//       Object.keys(paginationState.rightSideSendData)?.forEach(
//         (keysLoop, index) => {
//           paginationState.rightSideSendData?.[keysLoop]?.forEach(
//             (keysValue, index1) => {
//               // console.log({ keysValue });
//               if (keysValue?.length > 0) {
//                 // alert("here");
//                 obr[keysLoop] = keysValue;
//               }
//             }
//           );
//         }
//       );
//     }

//     // let objj1 =
//     //   paginationState.rightSideSendData?.[paginationState.pageNumber]?.length >
//     //   0
//     //     ? JSON.parse(JSON.stringify(paginationState.rightSideSendData))
//     //     : null;
//     // let objj2 =
//     //   paginationState.rightSideSendData?.[paginationState.pageNumber]?.length >
//     //   0
//     //     ? JSON.parse(JSON.stringify(paginationState.rightSideSendData))
//     //     : null;

//     let objj1 = paginationState.rightSideSendData
//       ? Object.keys(paginationState.rightSideSendData).some((dataaa) => {
//           // console.log(paginationState.rightSideSendData?.[dataaa]?.length);
//           return paginationState.rightSideSendData?.[dataaa]?.length > 0;
//         }) == true
//         ? paginationState.rightSideSendData
//         : null
//       : null;
//     let objj2 = paginationState.rightSideSendData
//       ? Object.keys(paginationState.rightSideSendData).some((dataaa) => {
//           // console.log(paginationState.rightSideSendData?.[dataaa]?.length);
//           return paginationState.rightSideSendData?.[dataaa]?.length > 0;
//         }) == true
//         ? paginationState.rightSideSendData
//         : null
//       : null;

//     // console.log(
//     //   "TTTTTTT",
//     //   { objj2, rightChecked, data1, data2, objj1, obr },
//     //   paginationState.leftSideSendData,
//     //   paginationState.rightSideSendData,

//     //   paginationState.rightSideSendData
//     //     ? Object.keys(paginationState.rightSideSendData).some((dataaa) => {
//     //         console.log(paginationState.rightSideSendData?.[dataaa]?.length);
//     //         return paginationState.rightSideSendData?.[dataaa]?.length > 0;
//     //       }) == true
//     //       ? paginationState.rightSideSendData
//     //       : null
//     //     : null
//     // );
//     let obbbj = {};
//     // Object.keys(objj2)?.forEach((element, index) => {
//     //   console.log("first0");
//     //   objj2?.[element]?.forEach((ele, indexx) => {
//     //     console.log("first1");
//     //     rightChecked?.forEach(async (element1, ind) => {
//     //       console.log("first", element1, ele);
//     //       if (paginationState.pageNumber != element) {
//     //         console.log("second");
//     //         if (element1.id == ele.id) {
//     //           if (!obbbj?.[index]) {
//     //             obbbj[index] = 0;
//     //           }

//     //           console.log(
//     //             "third",
//     //             { element1, ele, indexx, objj1, obbbj },
//     //             objj1?.[element]?.findIndex((i) => i.id === element1.id)
//     //           );
//     //           await objj1?.[element]?.splice(
//     //             // indexx - obbbj[index],
//     //             objj1?.[element]?.findIndex((i) => i.id === element1.id),
//     //             1
//     //             //   rightChecked.length > 0 ? rightChecked.length : 1
//     //           );
//     //           obbbj[index] = obbbj[index] + 1;
//     //         }
//     //       } else if (paginationState.pageNumber == element) {
//     //         const result1 = [];
//     //         objj1?.[element]?.forEach((obj1) => {
//     //           let found = false;

//     //           data1?.content?.forEach((obj2) => {
//     //             if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
//     //               found = true;
//     //             }
//     //           });

//     //           if (found) {
//     //             result1.push(obj1);
//     //           }
//     //         });

//     //         console.log("UUUUUUU", result1);
//     //       }
//     //     });
//     //   });
//     // });
//     let resultLast = [];
//     let resultLast1 = [];

//     if (objj2?.[paginationState.pageNumber]) {
//       Object.keys(objj2)?.forEach((element, index) => {
//         // console.log("first0");

//         objj2?.[element]?.forEach((ele, indexx) => {
//           // console.log("first1");
//           rightChecked?.forEach(async (element1, ind) => {
//             console.log("first", element1, ele);
//             if (paginationState.pageNumber != element) {
//               // console.log("second");
//               if (element1.id == ele.id) {
//                 if (!obbbj?.[index]) {
//                   obbbj[index] = 0;
//                 }

//                 // console.log(
//                 //   "third",
//                 //   { element1, ele, indexx, objj1, obbbj },
//                 //   objj1?.[element]?.findIndex((i) => i.id === element1.id)
//                 // );
//                 await objj1?.[element]?.splice(
//                   // indexx - obbbj[index],
//                   objj1?.[element]?.findIndex((i) => i.id === element1.id),
//                   1
//                   //   rightChecked.length > 0 ? rightChecked.length : 1
//                 );
//                 obbbj[index] = obbbj[index] + 1;
//               }
//             } else if (paginationState.pageNumber == element) {
//               // console.log("second1");
//               const result1 = [];
//               const result2 = [];
//               objj1?.[element]?.forEach(async (obj1) => {
//                 let found = false;

//                 data1?.content?.forEach(async (obj2) => {
//                   rightChecked?.forEach((obj3) => {
//                     if (
//                       JSON.stringify(obj1) === JSON.stringify(obj2) &&
//                       JSON.stringify(obj1) === JSON.stringify(obj3) &&
//                       JSON.stringify(obj2) === JSON.stringify(obj3)
//                     ) {
//                       found = true;
//                     }
//                   });
//                 });

//                 if (found) {
//                   // console.log("HHHHHHH", objj1?.[element]);
//                   //   alert("here");
//                   objj1?.[element]?.splice(
//                     // indexx - obbbj[index],
//                     objj1?.[element]?.findIndex((i) => i.id === element1.id),
//                     1
//                     //   rightChecked.length > 0 ? rightChecked.length : 1
//                   );
//                   result1.push(obj1);
//                 }
//               });
//               rightChecked?.forEach((obj1) => {
//                 let found = false;

//                 data2?.content?.forEach((obj2) => {
//                   if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
//                     found = true;
//                   }
//                 });

//                 if (found) {
//                   result2.push(obj1);
//                 }
//               });

//               if (rightChecked?.length - 1 == ind) {
//                 resultLast = result1;
//                 resultLast1 = result2;
//               }

//               // console.log("UUUUUUU", result1, result2);
//             }
//           });
//         });
//       });
//     } else {
//       rightChecked?.forEach((obj1) => {
//         let found = false;

//         data2?.content?.forEach((obj2) => {
//           // console.log("BBBBBBBBBB", obj1, obj2, rightChecked, data2?.content);
//           if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
//             found = true;
//           }
//         });

//         if (found) {
//           resultLast1.push(obj1);
//         }
//       });
//     }

//     // rightChecked?.forEach((obj1) => {
//     //   let found = false;

//     //   data2?.content?.forEach((obj2) => {
//     //     if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
//     //       found = true;
//     //     }
//     //   });

//     //   if (found) {
//     //     resultLast.push(obj1);
//     //   }
//     // });

//     // console.log(
//     //   { objj1, objj2, resultLast, resultLast1 },
//     //   paginationState.leftSideSendData?.[paginationState.rightPageNumber]
//     // );

//     setPaginationState({
//       ...paginationState,
//       leftsideAddedData: {
//         ...paginationState.leftsideAddedData,
//         [paginationState.pageNumber]:
//           resultLast?.length > 0 ? resultLast : rightChecked,
//       },
//       //   leftsideAddedData: {
//       //     ...paginationState.leftsideAddedData,
//       //     [paginationState.pageNumber]: paginationState.leftsideAddedData?.[
//       //       paginationState.pageNumber
//       //     ]
//       //       ? [
//       //           ...paginationState.leftsideAddedData?.[
//       //             paginationState.pageNumber
//       //           ],
//       //           ...rightChecked,
//       //         ]
//       //       : rightChecked,
//       //   },
//       //   leftSideSendData: {
//       //     ...paginationState.leftSideSendData,
//       //     [paginationState.rightPageNumber]: paginationState.leftSideSendData?.[
//       //       paginationState.rightPageNumber
//       //     ]
//       //       ? [
//       //           ...paginationState.leftSideSendData?.[
//       //             paginationState.rightPageNumber
//       //           ],
//       //           ...leftChecked,
//       //         ]
//       //       : leftChecked,
//       //   },
//       leftSideSendData: {
//         ...paginationState.leftSideSendData,
//         [paginationState.rightPageNumber]: paginationState.leftSideSendData?.[
//           paginationState.rightPageNumber
//         ]
//           ? [
//               ...paginationState.leftSideSendData?.[
//                 paginationState.rightPageNumber
//               ],
//               ...resultLast1,
//             ]
//           : resultLast1?.length > 0
//           ? resultLast1
//           : // : rightChecked,
//             resultLast1,
//         //    rightChecked
//       },

//       rightsideAddedData: objj,
//       rightSideSendData: objj1,
//       //   rightsideAddedData: {
//       //     ...paginationState.rightsideAddedData,
//       //     [paginationState.pageNumber]: rightChecked,
//       //   },
//     });

//     localStorage.setItem("phonebookrightSideSendData", JSON.stringify(objj1));

//     // console.log({ objj });

//     // paginationState.rightsideAddedData?.[0]?.forEach((ele, indexx) => {
//     //     rightChecked?.forEach((element1, ind) => {
//     //       if (element1.id == ele.id) {
//     //         objj?.[0]?.splice(
//     //           indexx,
//     //           rightChecked.length > 0 ? rightChecked.length : 1
//     //         );
//     //       }
//     //     });
//     //   });

//     // setPaginationState({
//     //     ...paginationState,
//     //     leftsideAddedData: {
//     //       ...paginationState.leftsideAddedData,
//     //       [0]: paginationState.leftsideAddedData?.[0]
//     //         ? [...paginationState.leftsideAddedData?.[0], ...rightChecked]
//     //         : rightChecked,
//     //     },
//     //     rightsideAddedData: objj,
//     //     //   rightsideAddedData: {
//     //     //     ...paginationState.rightsideAddedData,
//     //     //     [paginationState.pageNumber]: rightChecked,
//     //     //   },
//     //   });
//   };

//   async function ContactGet(values) {
//     if (paginationState?.searchValue == "") {
//       try {
//         setHideSkeleton(true);
//         const res = await common_axios.post(
//           `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/user-contacts/v2/list`,
//           {
//             pagination: {
//               pageNo: paginationState.pageNumber,
//               pageSize: paginationState.pageSize,
//             },
//           }
//         );
//         if (res.data.statusdescription.statusCode == 200) {
//           setHideSkeleton(false);
//           setLeft();
//           if (res.data?.page?.content) {
//             setData1(res.data.page);
//             // setPermanentData(res.data.page)
//             const result = [];

//             res.data?.page?.content.forEach((obj1) => {
//               let found = false;

//               right1.forEach((obj2) => {
//                 if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
//                   found = true;
//                 }
//               });

//               if (!found) {
//                 result.push(obj1);
//               }
//             });
//             setLeft(result);
//           }
//         } else {
//           setHideSkeleton(false);
//           Swal.fire({
//             icon: "error",
//             title: "Oops...",
//             text: res.data.statusdescription.statusDescription,
//           });
//         }
//       } catch (error) {
//         setHideSkeleton(false);
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: "Please Check Your Network",
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       }
//     } else {
//       try {
//         setHideSkeleton(true);
//         const res = await common_axios.post(
//           `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/v1/search/contact`,
//           {
//             pagination: {
//               pageNo: paginationState.pageNumber,
//               pageSize: paginationState.pageSize,
//             },
//             msisdn: null,
//             contactName: paginationState?.searchValue,
//           }
//         );
//         if (res.data.statusdescription.statusCode == 200) {
//           setHideSkeleton(false);
//           setLeft();
//           if (res.data?.page?.content) {
//             setData1(res.data.page);
//             setLeft(res.data?.page?.content);
//           }
//         } else {
//           setHideSkeleton(false);
//           // toast.error(res.data.statusdescription.statusDescription, {
//           //   toastId: customId1,
//           // });
//           Swal.fire({
//             icon: "error",
//             title: "Oops...",
//             text: res.data.statusdescription.statusDescription,
//             // footer: '<a href="">Why do I have this issue?</a>'
//           });
//         }
//       } catch (error) {
//         setHideSkeleton(false);

//         // toast.error("Please Check Your Network", {
//         //   toastId: customId1,
//         // });
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: "Please Check Your Network",
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       }
//     }
//   }

//   useEffect(() => {
//     setRight([]);
//     setRight1([]);
//     setRight2([]);
//     // if (permanentArray?.length > 0) {
//     //   setTimeout(() => {
//     //     setLeft(permanentArray);
//     //   }, 100);
//     // }
//   }, [resetState]);
//   async function ContactGetEdit(values) {
//     if (paginationState?.searchValue == "") {
//       try {
//         setHideSkeleton(true);
//         let res = await common_axios.post(
//           `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/v1/get/phoneBook/user-contacts`,
//           {
//             pagination: {
//               pageNo: paginationState.pageNumber,
//               pageSize: paginationState.pageSize,
//               rightSidePageSize: paginationState.rightPageSize,
//               rightSidePageNo: paginationState.rightPageNumber,
//             },
//             phoneBookId: rightData?.id,
//           }
//         );
//         if (res.data.statusdescription.statusCode == 200) {
//           setHideSkeleton(false);

//           // setData1(res.data.page);
//           //   const result = [];
//           //   res.data?.page?.content.forEach((obj1) => {
//           //     let found = false;
//           //     right1.forEach((obj2) => {
//           //       if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
//           //         found = true;
//           //       }
//           //     });
//           //     if (!found) {
//           //       result.push(obj1);
//           //     }
//           //   });
//           //   console.log({ result });

//           //   if (
//           //     pageType == "EditPage" &&
//           //     (paginationState?.leftsideAddedData?.[
//           //       paginationState?.pageNumber
//           //     ] ||
//           //       paginationState?.rightsideAddedData?.[
//           //         paginationState?.rightPageNumber
//           //       ])
//           //   ) {
//           if (pageType == "EditPage") {
//             // alert("In main");
//             let leftArr = res.data?.leftUsers?.content;
//             let rightArr = res.data?.righUser?.content;
//             if (paginationState?.leftsideAddedData) {
//               //   alert("here");
//               // console.log(
//               //   "OOOOOO",
//               //   paginationState?.leftsideAddedData?.[
//               //     paginationState?.pageNumber
//               //   ]
//               // );

//               if (
//                 paginationState?.leftsideAddedData?.[
//                   paginationState?.pageNumber
//                 ]
//               ) {
//                 // alert("here up");

//                 const result1 = [];
//                 res.data?.leftUsers?.content?.forEach((obj1) => {
//                   let found = false;
//                   Object.keys(paginationState?.leftsideAddedData)?.forEach(
//                     (dddata, index) => {
//                       // console.log({ dddata });

//                       paginationState?.leftsideAddedData?.[dddata]?.forEach(
//                         (obj2) => {
//                           if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
//                             found = true;
//                           }
//                         }
//                       );
//                     }
//                   );

//                   if (!found) {
//                     result1.push(obj1);
//                   }
//                 });

//                 // console.log("WWWWWW", result1);

//                 // leftArr = res.data?.leftUsers?.content.concat(
//                 //   paginationState?.leftsideAddedData?.[
//                 //     paginationState?.pageNumber
//                 //   ]
//                 // );
//                 leftArr = result1.concat(
//                   paginationState?.leftsideAddedData?.[
//                     paginationState?.pageNumber
//                   ]
//                 );
//               } else {
//                 leftArr = res.data?.leftUsers?.content;
//               }

//               let result = [];

//               let result1 = [];
//               let result2 = [];
//               // res.data?.righUser?.content?.forEach((obj1) => {
//               //   let found = false;
//               //   paginationState?.leftsideAddedData?.[
//               //     paginationState?.pageNumber
//               //   ]?.forEach((obj2) => {
//               //     if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
//               //       found = true;
//               //     }
//               //   });
//               //   if (!found) {
//               //     result.push(obj1);
//               //   }
//               // });

//               //   res.data?.righUser?.content?.forEach((obj1) => {
//               //     let found = false;

//               //     paginationState?.leftsideAddedData?.[0]?.forEach((obj2) => {
//               //       if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
//               //         found = true;
//               //       }
//               //     });

//               //     if (!found) {
//               //       result1.push(obj1);
//               //     }
//               //   });

//               res.data?.righUser?.content?.forEach((obj1) => {
//                 let found = false;
//                 Object.keys(paginationState?.leftsideAddedData)?.forEach(
//                   (dddata, index) => {
//                     // console.log(":::::::", { dddata });

//                     paginationState?.leftsideAddedData?.[dddata]?.forEach(
//                       (obj2) => {
//                         if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
//                           found = true;
//                         }
//                       }
//                     );
//                   }
//                 );

//                 if (!found) {
//                   result1.push(obj1);
//                 }
//               });

//               // console.log("here", result1, paginationState?.rightsideAddedData);

//               //   result1?.forEach((obj1) => {
//               //     let found = false;

//               //     paginationState?.rightsideAddedData?.[0]?.forEach((obj2) => {
//               //       if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
//               //         found = true;
//               //       }
//               //     });

//               //     if (!found) {
//               //       result2.push(obj1);
//               //     }
//               //   });
//               if (paginationState?.rightsideAddedData) {
//                 result1?.forEach((obj1) => {
//                   let found = false;
//                   Object.keys(paginationState?.rightsideAddedData)?.forEach(
//                     (dddata, index) => {
//                       // console.log(";;;;;;;;;", { dddata });

//                       paginationState?.rightsideAddedData?.[dddata]?.forEach(
//                         (obj2) => {
//                           if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
//                             found = true;
//                           }
//                         }
//                       );
//                     }
//                   );

//                   if (!found) {
//                     result2.push(obj1);
//                   }
//                 });
//               } else {
//                 result2 = result1;
//               }

//               // console.log({ result, result1, result2 });
//               rightArr = result2;
//             }

//             if (
//               paginationState?.rightsideAddedData &&
//               res.data?.leftUsers?.content &&
//               res.data?.righUser?.content
//             ) {
//               //   alert("now");
//               // console.log(
//               //   "PPPPPP",
//               //   paginationState?.rightsideAddedData?.[
//               //     paginationState?.rightPageNumber
//               //   ]
//               // );
//               //   if (rightArr?.length > 0) {

//               if (
//                 paginationState?.rightsideAddedData?.[
//                   paginationState?.rightPageNumber
//                 ]
//               ) {
//                 rightArr = rightArr.concat(
//                   paginationState?.rightsideAddedData?.[
//                     paginationState?.rightPageNumber
//                   ]
//                 );
//               }
//               // paginationState?.rightsideAddedData?.[
//               //   paginationState?.rightPageNumber
//               // ]
//               //   ? (rightArr = rightArr.concat(
//               //       paginationState?.rightsideAddedData?.[
//               //         paginationState?.rightPageNumber
//               //       ]
//               //     ))
//               //   : (rightArr = rightArr);
//               //   } else {
//               //     paginationState?.rightsideAddedData?.[
//               //       paginationState?.rightPageNumber
//               //     ]
//               //       ? (rightArr = res.data?.righUser?.content.concat(
//               //           paginationState?.rightsideAddedData?.[
//               //             paginationState?.rightPageNumber
//               //           ]
//               //         ))
//               //       : (rightArr = res.data?.righUser?.content);
//               //   }
//               //   setRight(
//               //     res.data?.righUser?.content.concat(
//               //       paginationState?.rightsideAddedData?.[
//               //         paginationState?.rightPageNumber
//               //       ]
//               //     )
//               //   );
//               const result = [];
//               const result1 = [];
//               if (leftArr?.length > 0) {
//                 // leftArr?.forEach((obj1) => {
//                 //   let found = false;
//                 //   paginationState?.rightsideAddedData?.[
//                 //     paginationState?.rightPageNumber
//                 //   ]?.forEach((obj2) => {
//                 //     if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
//                 //       found = true;
//                 //     }
//                 //   });
//                 //   if (!found) {
//                 //     result.push(obj1);
//                 //   }
//                 // });

//                 // leftArr?.forEach((obj1) => {
//                 //   let found = false;
//                 //   //   Object.keys(paginationState?.rightsideAddedData)?.forEach(
//                 //   //     (dddata, index) => {

//                 //   paginationState?.rightsideAddedData?.[0]?.forEach((obj2) => {
//                 //     if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
//                 //       found = true;
//                 //     }
//                 //   });
//                 //   //     }
//                 //   //   );

//                 //   if (!found) {
//                 //     result1.push(obj1);
//                 //   }
//                 // });

//                 leftArr?.forEach((obj1) => {
//                   let found = false;
//                   Object.keys(paginationState?.rightsideAddedData)?.forEach(
//                     (dddata, index) => {
//                       // console.log({ dddata });

//                       paginationState?.rightsideAddedData?.[dddata]?.forEach(
//                         (obj2) => {
//                           if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
//                             found = true;
//                           }
//                         }
//                       );
//                     }
//                   );

//                   if (!found) {
//                     result1.push(obj1);
//                   }
//                 });
//               } else {
//                 // res.data?.leftUsers?.content.forEach((obj1) => {
//                 //   let found = false;
//                 //   paginationState?.rightsideAddedData?.[
//                 //     paginationState?.rightPageNumber
//                 //   ]?.forEach((obj2) => {
//                 //     if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
//                 //       found = true;
//                 //     }
//                 //   });
//                 //   if (!found) {
//                 //     result.push(obj1);
//                 //   }
//                 // });

//                 // res.data?.leftUsers?.content?.forEach((obj1) => {
//                 //   let found = false;

//                 //   paginationState?.rightsideAddedData?.[0]?.forEach((obj2) => {
//                 //     if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
//                 //       found = true;
//                 //     }
//                 //   });

//                 //   if (!found) {
//                 //     result1.push(obj1);
//                 //   }
//                 // });

//                 res.data?.leftUsers?.content?.forEach((obj1) => {
//                   let found = false;
//                   Object.keys(paginationState?.rightsideAddedData)?.forEach(
//                     (dddata, index) => {
//                       // console.log({ dddata });

//                       paginationState?.rightsideAddedData?.[dddata]?.forEach(
//                         (obj2) => {
//                           if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
//                             found = true;
//                           }
//                         }
//                       );
//                     }
//                   );

//                   if (!found) {
//                     result1.push(obj1);
//                   }
//                 });
//               }
//               // console.log({ result, result1 });
//               leftArr = result1;
//               //   setLeft(result);
//               // setLeft(
//               //   not(
//               //     res.data?.leftUsers?.content,
//               //     paginationState?.rightsideAddedData?.[
//               //       paginationState?.rightPageNumber
//               //     ]
//               //   )
//               // );
//             }
//             // console.log({ leftArr, rightArr });
//             setLeft(leftArr);
//             setRight(rightArr);
//             setRight1(rightArr);
//             setRight2(rightArr);
//             if (res.data?.leftUsers?.content) {
//               setData1(res.data.leftUsers);
//             }
//             if (res.data?.righUser?.content) {
//               setData2(res.data?.righUser);
//             }
//           } else {
//             if (res.data?.leftUsers?.content) {
//               setData1(res.data.leftUsers);
//               setLeft(res.data?.leftUsers?.content);
//             }
//             if (res.data?.righUser?.content) {
//               setData2(res.data?.righUser);
//               setRight(res.data?.righUser?.content);
//               setRight1(res.data?.righUser?.content);
//               setRight2(res.data?.righUser?.content);
//             }
//           }
//         } else {
//           setHideSkeleton(false);
//           // toast.error(res.data.statusdescription.statusDescription, {
//           //   toastId: customId1,
//           // });
//           Swal.fire({
//             icon: "error",
//             title: "Oops...",
//             text: res.data.statusdescription.statusDescription,
//             // footer: '<a href="">Why do I have this issue?</a>'
//           });
//         }
//       } catch (error) {
//         setHideSkeleton(false);
//         // console.log({ error });
//         // toast.error("Please Check Your Network", {
//         //   toastId: customId1,
//         // });
//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: "Please Check Your Network",
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       }
//     } else {
//       //   try {
//       //     setHideSkeleton(true);
//       //     const res = await common_axios.post(
//       //       `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/v1/search/contact`,
//       //       {
//       //         pagination: {
//       //           pageNo: paginationState.pageNumber,
//       //           pageSize: paginationState.pageSize,
//       //         },
//       //         msisdn: null,
//       //         contactName: paginationState?.searchValue,
//       //       }
//       //     );
//       //     if (res.data.statusdescription.statusCode == 200) {
//       //       setHideSkeleton(false);
//       //       setLeft();
//       //       if (res.data?.page?.content) {
//       //         setData1(res.data.page);
//       //         setLeft(res.data?.page?.content);
//       //       }
//       //     } else {
//       //       setHideSkeleton(false);
//       //       toast.error(res.data.statusdescription.statusDescription, {
//       //         toastId: customId1,
//       //       });
//       //     }
//       //   } catch (error) {
//       //     setHideSkeleton(false);
//       //     toast.error("Please Check Your Network", {
//       //       toastId: customId1,
//       //     });
//       //   }

//       try {
//         setHideSkeleton(true);
//         let res = await common_axios.post(
//           `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/v1/search/phoneBook/user-contacts`,
//           {
//             pagination: {
//               pageNo: paginationState.pageNumber,
//               pageSize: paginationState.pageSize,
//               rightSidePageSize: paginationState.rightPageSize,
//               rightSidePageNo: paginationState.rightPageNumber,
//             },
//             phoneBookId: rightData?.id,
//             contactName: paginationState?.searchValue,
//           }
//         );
//         if (res.data.statusdescription.statusCode == 200) {
//           setHideSkeleton(false);

//           // setData1(res.data.page);
//           //   const result = [];
//           //   res.data?.page?.content.forEach((obj1) => {
//           //     let found = false;
//           //     right1.forEach((obj2) => {
//           //       if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
//           //         found = true;
//           //       }
//           //     });
//           //     if (!found) {
//           //       result.push(obj1);
//           //     }
//           //   });
//           //   console.log({ result });

//           //   if (
//           //     pageType == "EditPage" &&
//           //     (paginationState?.leftsideAddedData?.[
//           //       paginationState?.pageNumber
//           //     ] ||
//           //       paginationState?.rightsideAddedData?.[
//           //         paginationState?.rightPageNumber
//           //       ])
//           //   ) {
//           if (pageType == "EditPage") {
//             // alert("In main");
//             let leftArr = res.data?.leftUsers?.content;
//             let rightArr = res.data?.righUser?.content;
//             if (paginationState?.leftsideAddedData) {
//               //   alert("here");
//               // console.log(
//               //   "OOOOOO",
//               //   paginationState?.leftsideAddedData?.[
//               //     paginationState?.pageNumber
//               //   ]
//               // );

//               if (
//                 paginationState?.leftsideAddedData?.[
//                   paginationState?.pageNumber
//                 ]
//               ) {
//                 const result1 = [];
//                 // res.data?.leftUsers?.content?.forEach((obj1) => {
//                 //   let found = false;

//                 //   paginationState?.leftsideAddedData?.[0]?.forEach((obj2) => {
//                 //     if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
//                 //       found = true;
//                 //     }
//                 //   });

//                 //   if (!found) {
//                 //     result1.push(obj1);
//                 //   }
//                 // });

//                 res.data?.leftUsers?.content?.forEach((obj1) => {
//                   let found = false;
//                   Object.keys(paginationState?.leftsideAddedData)?.forEach(
//                     (dddata, index) => {
//                       // console.log({ dddata });

//                       paginationState?.leftsideAddedData?.[dddata]?.forEach(
//                         (obj2) => {
//                           if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
//                             found = true;
//                           }
//                         }
//                       );
//                     }
//                   );

//                   if (!found) {
//                     result1.push(obj1);
//                   }
//                 });

//                 // leftArr = result1; // don`t add left side moved data and filter data remove which are removed from left

//                 leftArr = result1.concat(
//                   paginationState?.leftsideAddedData?.[ //  add left side moved data and filter data remove which are removed from left
//                     paginationState?.pageNumber
//                   ]
//                     ?.filter(
//                       (ddd, index) =>
//                         ddd?.contactName
//                           ?.toLowerCase()
//                           ?.includes(
//                             paginationState?.searchValue?.toLowerCase()
//                           ) // now filtering data based on input
//                     )
//                 );

//                 // leftArr = res.data?.leftUsers?.content.concat( //  add left side moved data
//                 //   paginationState?.leftsideAddedData?.[
//                 //     paginationState?.pageNumber
//                 //   ]
//                 // );
//               } else {
//                 leftArr = res.data?.leftUsers?.content;
//               }

//               const result = [];
//               //   res.data?.righUser?.content?.forEach((obj1) => {
//               //     let found = false;
//               //     paginationState?.leftsideAddedData?.[
//               //       paginationState?.pageNumber
//               //     ]?.forEach((obj2) => {
//               //       if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
//               //         found = true;
//               //       }
//               //     });
//               //     if (!found) {
//               //       result.push(obj1);
//               //     }
//               //   });

//               const result1 = [];
//               //   res.data?.righUser?.content?.forEach((obj1) => {
//               //     let found = false;

//               //     paginationState?.leftsideAddedData?.[0]?.forEach((obj2) => {
//               //       if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
//               //         found = true;
//               //       }
//               //     });

//               //     if (!found) {
//               //       result1.push(obj1);
//               //     }
//               //   });

//               res.data?.righUser?.content?.forEach((obj1) => {
//                 let found = false;
//                 Object.keys(paginationState?.leftsideAddedData)?.forEach(
//                   (dddata, index) => {
//                     // console.log({ dddata });

//                     paginationState?.leftsideAddedData?.[dddata]?.forEach(
//                       (obj2) => {
//                         if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
//                           found = true;
//                         }
//                       }
//                     );
//                   }
//                 );

//                 if (!found) {
//                   result1.push(obj1);
//                 }
//               });

//               // console.log({ result, result1 });
//               rightArr = result1;
//             }

//             if (
//               paginationState?.rightsideAddedData &&
//               res.data?.righUser?.content
//               //   res.data?.leftUsers?.content &&
//             ) {
//               //   alert("now");
//               // console.log(
//               //   "PPPPPP",
//               //   paginationState?.rightsideAddedData?.[
//               //     paginationState?.rightPageNumber
//               //   ]
//               // );
//               //   if (rightArr?.length > 0) {
//               // alert("if");

//               const result2 = [];
//               //   rightArr?.forEach((obj1) => {
//               //     let found = false;

//               //     paginationState?.rightsideAddedData?.[0]?.forEach((obj2) => {
//               //       if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
//               //         found = true;
//               //       }
//               //     });

//               //     if (!found) {
//               //       result2.push(obj1);
//               //     }
//               //   });

//               rightArr?.forEach((obj1) => {
//                 let found = false;
//                 Object.keys(paginationState?.rightsideAddedData)?.forEach(
//                   (dddata, index) => {
//                     // console.log({ dddata });

//                     paginationState?.rightsideAddedData?.[dddata]?.forEach(
//                       (obj2) => {
//                         if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
//                           found = true;
//                         }
//                       }
//                     );
//                   }
//                 );

//                 if (!found) {
//                   result2.push(obj1);
//                 }
//               });

//               // console.log("LLLLLLLL", { result2 });
//               rightArr = result2;

//               // console.log(
//               //   "KKKKKKKK",
//               //   rightArr.concat(
//               //     paginationState?.rightsideAddedData?.[
//               //       paginationState?.rightPageNumber
//               //     ]
//               //   )
//               // );

//               //   paginationState?.rightsideAddedData?.[
//               //     paginationState?.rightPageNumber
//               //   ]
//               //     ? alert("here good")(
//               //         (rightArr = rightArr.concat(
//               //           paginationState?.rightsideAddedData?.[
//               //             paginationState?.rightPageNumber
//               //           ]
//               //         ))
//               //       )
//               //     : alert("here bad")((rightArr = rightArr));

//               if (
//                 paginationState?.rightsideAddedData?.[
//                   paginationState?.rightPageNumber
//                 ]
//               ) {
//                 rightArr = rightArr.concat(
//                   paginationState?.rightsideAddedData?.[
//                     paginationState?.rightPageNumber
//                   ]?.filter(
//                     (ddd, index) =>
//                       ddd?.contactName
//                         ?.toLowerCase()
//                         ?.includes(paginationState?.searchValue?.toLowerCase()) // now filtering data based on input
//                   )
//                 );
//               }

//               // console.log("TTTTTTTT", rightArr);
//               //   }
//               //   else {
//               //     alert("else");

//               //     const result1 = [];
//               //     res.data?.righUser?.content?.forEach((obj1) => {
//               //       let found = false;
//               //       Object.keys(paginationState?.leftsideAddedData)?.forEach(
//               //         (dddata, index) => {
//               //           console.log({ dddata });

//               //           paginationState?.leftsideAddedData?.[dddata]?.forEach(
//               //             (obj2) => {
//               //               if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
//               //                 found = true;
//               //               }
//               //             }
//               //           );
//               //         }
//               //       );

//               //       if (!found) {
//               //         result1.push(obj1);
//               //       }
//               //     });

//               //     console.log("LLLLLLLL", { result1 });

//               //     rightArr = result1;

//               //     // paginationState?.rightsideAddedData?.[
//               //     //   paginationState?.rightPageNumber
//               //     // ]
//               //     //   ? (rightArr = result1.concat(
//               //     //       paginationState?.rightsideAddedData?.[
//               //     //         paginationState?.rightPageNumber
//               //     //       ]
//               //     //     ))
//               //     //   : (rightArr = result1);

//               //     // paginationState?.rightsideAddedData?.[
//               //     //   paginationState?.rightPageNumber
//               //     // ]
//               //     //   ? (rightArr = res.data?.righUser?.content.concat(
//               //     //       paginationState?.rightsideAddedData?.[
//               //     //         paginationState?.rightPageNumber
//               //     //       ]
//               //     //     ))
//               //     //   : (rightArr = res.data?.righUser?.content);
//               //   }
//               //   setRight(
//               //     res.data?.righUser?.content.concat(
//               //       paginationState?.rightsideAddedData?.[
//               //         paginationState?.rightPageNumber
//               //       ]
//               //     )
//               //   );
//               const result = [];
//               const result1 = [];
//               //   if (leftArr?.length > 0) {
//               // leftArr?.forEach((obj1) => {
//               //   let found = false;
//               //   paginationState?.rightsideAddedData?.[
//               //     paginationState?.rightPageNumber
//               //   ]?.forEach((obj2) => {
//               //     if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
//               //       found = true;
//               //     }
//               //   });
//               //   if (!found) {
//               //     result.push(obj1);
//               //   }
//               // });

//               //   leftArr?.forEach((obj1) => {
//               //     let found = false;

//               //     paginationState?.rightsideAddedData?.[0]?.forEach((obj2) => {
//               //       if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
//               //         found = true;
//               //       }
//               //     });

//               //     if (!found) {
//               //       result1.push(obj1);
//               //     }
//               //   });

//               leftArr?.forEach((obj1) => {
//                 let found = false;
//                 Object.keys(paginationState?.rightsideAddedData)?.forEach(
//                   (dddata, index) => {
//                     // console.log({ dddata });

//                     paginationState?.rightsideAddedData?.[dddata]?.forEach(
//                       (obj2) => {
//                         if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
//                           found = true;
//                         }
//                       }
//                     );
//                   }
//                 );

//                 if (!found) {
//                   result1.push(obj1);
//                 }
//               });
//               //   }
//               //   else {
//               //     // res.data?.leftUsers?.content.forEach((obj1) => {
//               //     //   let found = false;
//               //     //   paginationState?.rightsideAddedData?.[
//               //     //     paginationState?.rightPageNumber
//               //     //   ]?.forEach((obj2) => {
//               //     //     if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
//               //     //       found = true;
//               //     //     }
//               //     //   });
//               //     //   if (!found) {
//               //     //     result.push(obj1);
//               //     //   }
//               //     // });

//               //     res.data?.leftUsers?.content?.forEach((obj1) => {
//               //       let found = false;
//               //       Object.keys(paginationState?.rightsideAddedData)?.forEach(
//               //         (dddata, index) => {
//               //           console.log({ dddata });

//               //           paginationState?.rightsideAddedData?.[dddata]?.forEach(
//               //             (obj2) => {
//               //               if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
//               //                 found = true;
//               //               }
//               //             }
//               //           );
//               //         }
//               //       );

//               //       if (!found) {
//               //         result1.push(obj1);
//               //       }
//               //     });
//               //   }
//               // console.log({ result, result1 });
//               leftArr = result1;
//               //   setLeft(result);
//               // setLeft(
//               //   not(
//               //     res.data?.leftUsers?.content,
//               //     paginationState?.rightsideAddedData?.[
//               //       paginationState?.rightPageNumber
//               //     ]
//               //   )
//               // );
//             }
//             // console.log({ leftArr, rightArr });
//             setLeft(leftArr);
//             setRight(rightArr);
//             setRight1(rightArr);
//             setRight2(rightArr);
//             if (res.data?.leftUsers?.content) {
//               setData1(res.data.leftUsers);
//             }
//             if (res.data?.righUser?.content) {
//               setData2(res.data?.righUser);
//             }
//           } else {
//             if (res.data?.leftUsers?.content) {
//               setData1(res.data.leftUsers);
//               setLeft(res.data?.leftUsers?.content);
//             }
//             if (res.data?.righUser?.content) {
//               setData2(res.data?.righUser);
//               setRight(res.data?.righUser?.content);
//               setRight1(res.data?.righUser?.content);
//               setRight2(res.data?.righUser?.content);
//             }
//           }
//         } else {
//           setHideSkeleton(false);
//           // toast.error(res.data.statusdescription.statusDescription, {
//           //   toastId: customId1,
//           // });
//           Swal.fire({
//             icon: "error",
//             title: "Oops...",
//             text: res.data.statusdescription.statusDescription,
//             // footer: '<a href="">Why do I have this issue?</a>'
//           });
//         }
//       } catch (error) {
//         setHideSkeleton(false);

//         // toast.error("Please Check Your Network", {
//         //   toastId: customId1,
//         // });

//         Swal.fire({
//           icon: "error",
//           title: "Oops...",
//           text: "Please Check Your Network",
//           // footer: '<a href="">Why do I have this issue?</a>'
//         });
//       }
//     }
//   }

//   React.useEffect(() => {
//     if (pageType == "EditPage" && rightData?.id) {
//       ContactGetEdit();
//     }
//   }, [
//     paginationState?.pageNumber,
//     paginationState.searchValue,
//     paginationState.rightPageNumber,
//     paginationState.rightPageSize,
//   ]);

//   React.useEffect(() => {
//     if (
//       left?.length == 0 &&
//       paginationState.buttonLeftToRight &&
//       paginationState.searchValue == "" &&
//       pageType != "EditPage" &&
//       data1?.totalPages - 1 > paginationState.pageNumber
//     ) {
//       setPaginationState({
//         ...paginationState,
//         pageNumber: paginationState.pageNumber + 1,
//       });
//     }
//   }, [left, paginationState.buttonLeftToRight]);

//   React.useEffect(() => {
//     if (pageType != "EditPage") {
//       ContactGet();
//     }
//   }, [paginationState?.pageNumber, paginationState.searchValue]);

//   useEffect(() => {
//     if (pageType != "EditPage") {
//       onData(right1);
//     }
//   }, [right1]);

//   useEffect(() => {
//     if (pageType == "EditPage") {
//       let arr = {
//         rightsideAddedData: paginationState.rightSideSendData,
//         leftsideAddedData: paginationState.leftSideSendData,
//       };
//       onData(arr);
//     }
//   }, [paginationState.rightsideAddedData, paginationState.leftsideAddedData]);

//   useEffect(() => {
//     // console.log("object", rightData, rightData?.length);
//     if (rightData && rightData?.id) {
//       ContactGetEdit();
//     }
//   }, [rightData]);

//   useEffect(() => {
//     if (right2 && right2?.length > 0) {
//       if (pageType != "EditPage") {
//         ContactGet();
//       }
//     }
//   }, [right2]);

//   //   useEffect(() => {
//   //     if (pageType == "EditPage" && right?.length > 0) {
//   //       if (
//   //         paginationState?.rightsideAddedData?.[paginationState?.rightPageNumber]
//   //       ) {
//   //         alert("now");
//   //         console.log(
//   //           "PPPPPP",
//   //           paginationState?.rightsideAddedData?.[
//   //             paginationState?.rightPageNumber
//   //           ],
//   //           right.concat(
//   //             paginationState?.rightsideAddedData?.[
//   //               paginationState?.rightPageNumber
//   //             ]
//   //           )
//   //         );
//   //         setRight(
//   //           right.concat(
//   //             paginationState?.rightsideAddedData?.[
//   //               paginationState?.rightPageNumber
//   //             ]
//   //           )
//   //         );
//   //         setLeft(
//   //           not(
//   //             left,
//   //             paginationState?.rightsideAddedData?.[
//   //               paginationState?.rightPageNumber
//   //             ]
//   //           )
//   //         );
//   //       }
//   //     }
//   //   }, [paginationState?.rightPageNumber]);

//   const customList = (title, items) => (
//     <Card>
//       <CardHeader
//         sx={{ px: 2, py: 1 }}
//         avatar={
//           <Checkbox
//             onClick={handleToggleAll(items)}
//             checked={
//               numberOfChecked(items) === items?.length && items?.length !== 0
//             }
//             indeterminate={
//               numberOfChecked(items) !== items?.length &&
//               numberOfChecked(items) !== 0
//             }
//             disabled={items?.length === 0}
//             inputProps={{
//               "aria-label": "all items selected",
//             }}
//           />
//         }
//         title={title}
//         subheader={`${numberOfChecked(items)}/${
//           items?.length ? items?.length : 0
//         } selected`}
//       />
//       <Divider />
//       <div className="user_contact_list" style={{ padding: "16px" }}>
//         {title == "User Contact List" ? (
//           <div
//             className="d-flex align-items-center p-3 py-2"
//             style={{ border: "1px solid #ced4da" }}
//           >
//             {/* <TextField
//               className=" w-100"
//               style={{
//                 borderRadius: "4px",
//               }}
//               type="text"
//               label="Search here"
//               name="phonebookDescription"
//               variant="filled"
//               size="small"
//               InputProps={{
//                 startAdornment: (
//                   <InputAdornment position="start">
//                     <SearchIcon />
//                   </InputAdornment>
//                 ),
//               }}
//               value={paginationState?.searchValue}
//               onChange={(event) => {
//                 // onChange(event.target.value);
//                 setPaginationState({
//                   ...paginationState,
//                   pageNumber: 0,
//                   searchValue: event.target.value,
//                 });
//               }}
//             /> */}
//             <SearchIcon style={{ width: "1em", height: "1em" }} />

//             <input
//               type="text"
//               placeholder="Search here"
//               className="form-control"
//               style={{
//                 width: "100%",
//                 border: "none",
//                 padding: "0",
//                 fontSize: "14px",
//                 lineHeight: "normal",
//               }}
//               value={paginationState?.searchValue}
//               onChange={(event) => {
//                 // onChange(event.target.value);
//                 setPaginationState({
//                   ...paginationState,
//                   pageNumber: 0,
//                   searchValue: event.target.value,
//                 });
//               }}
//             />
//           </div>
//         ) : (
//           <div
//             className="d-flex align-items-center p-3 py-2"
//             style={{ border: "1px solid #ced4da" }}
//           >
//             {/* <TextField
//                 className=" w-100"
//                 style={{
//                   borderRadius: "4px",
//                 }}
//                 type="text"
//                 label="Search here"
//                 name="phonebookDescription"
//                 variant="filled"
//                 size="small"
//                 InputProps={{
//                   startAdornment: (
//                     <InputAdornment position="start">
//                       <SearchIcon />
//                     </InputAdornment>
//                   ),
//                 }}
//                 value={paginationState?.searchValue1}
//                 onChange={(event) => {
//                   setPaginationState({
//                     ...paginationState,
//                     searchValue1: event.target.value,
//                     rightPageNumber: 0,
//                   });
//                   const data = right1.filter((dddd, index) =>
//                     dddd.contactName
//                       .toLowerCase()
//                       .includes(event.target.value.toLowerCase())
//                   );
//                   console.log({ data, right1 });
//                   setRight(data);
//                 }}
//               /> */}

//             <SearchIcon style={{ width: "1em", height: "1em" }} />
//             {pageType == "EditPage" ? (
//               <input
//                 type="text"
//                 placeholder="Search here"
//                 className="form-control"
//                 style={{
//                   width: "100%",
//                   border: "none",
//                   padding: "0",
//                   fontSize: "14px",
//                   lineHeight: "normal",
//                 }}
//                 value={paginationState?.searchValue}
//                 onChange={(event) => {
//                   // onChange(event.target.value);
//                   setPaginationState({
//                     ...paginationState,
//                     pageNumber: 0,
//                     rightPageNumber: 0,
//                     searchValue: event.target.value,
//                   });
//                 }}
//               />
//             ) : (
//               <input
//                 type="text"
//                 placeholder="Search here"
//                 className="form-control"
//                 style={{
//                   width: "100%",
//                   border: "none",
//                   padding: "0",
//                   fontSize: "14px",
//                   lineHeight: "normal",
//                 }}
//                 value={paginationState?.searchValue1}
//                 onChange={(event) => {
//                   setPaginationState({
//                     ...paginationState,
//                     searchValue1: event.target.value,
//                     rightPageNumber: 0,
//                   });
//                   const data = right1.filter((dddd, index) =>
//                     dddd.contactName
//                       .toLowerCase()
//                       .includes(event.target.value.toLowerCase())
//                   );
//                   // console.log({ data, right1 });
//                   setRight(data);
//                 }}
//               />
//             )}
//           </div>
//         )}
//       </div>
//       <Divider />
//       {hideSkeleton &&
//       (title == "User Contact List" || pageType == "EditPage") ? (
//         <>
//           <Skeleton animation="wave" sx={{ width: width }} className="mt-3" />
//           <Skeleton animation="wave" />
//           <Skeleton animation="wave" />
//           <Skeleton animation="wave" />
//           <Skeleton animation="wave" />
//           <Skeleton animation="wave" />
//           <Skeleton animation="wave" />
//           <Skeleton animation="wave" />
//           <Skeleton animation="wave" />
//           <Skeleton animation="wave" />
//           <Skeleton animation="wave" />
//           <Skeleton animation="wave" />
//           <Skeleton animation="wave" />
//           <Skeleton animation="wave" />
//           <Skeleton animation="wave" />
//         </>
//       ) : (
//         <>
//           <List
//             sx={{
//               width: width,
//               height: height,
//               bgcolor: "background.paper",
//               overflow: "auto",
//             }}
//             dense
//             component="div"
//             role="list"
//           >
//             {items?.length == 0 ? (
//               <div className="text-center m-5 pt-5">
//                 <svg
//                   className="ant-empty-img-simple"
//                   width="64"
//                   height="41"
//                   viewBox="0 0 64 41"
//                   xmlns="http://www.w3.org/2000/svg"
//                 >
//                   <g transform="translate(0 1)" fill="none" fill-rule="evenodd">
//                     <ellipse
//                       className="ant-empty-img-simple-ellipse"
//                       cx="32"
//                       cy="33"
//                       rx="32"
//                       ry="7"
//                     ></ellipse>
//                     <g className="ant-empty-img-simple-g" fill-rule="nonzero">
//                       <path d="M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"></path>
//                       <path
//                         d="M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z"
//                         className="ant-empty-img-simple-path"
//                       ></path>
//                     </g>
//                   </g>
//                 </svg>
//                 <h5>No Data</h5>
//                 {title == "User Contact List" &&
//                 paginationState?.searchValue == "" &&
//                 paginationState.pageNumber + 1 < data1?.totalPages ? (
//                   <button
//                     className="ant-btn ant-btn-primary ant-btn-sm"
//                     onClick={() => {
//                       setPaginationState({
//                         ...paginationState,
//                         pageNumber: paginationState.pageNumber + 1,
//                       });
//                     }}
//                   >
//                     Go to Next Page
//                   </button>
//                 ) : null}
//               </div>
//             ) : (
//               <>
//                 {items &&
//                   items?.map((value, index) => {
//                     const labelId = `transfer-list-all-item-${value?.id}-${index}-label`;
//                     if (
//                       paginationState?.rightPageStartIndex <= index &&
//                       paginationState?.rightPageEndIndex > index &&
//                       title != "User Contact List" &&
//                       pageType != "EditPage"
//                     ) {
//                       return (
//                         <ListItem
//                           key={labelId}
//                           role="listitem"
//                           button
//                           onClick={handleToggle(value)}
//                         >
//                           <ListItemIcon>
//                             <Checkbox
//                               checked={checked.indexOf(value) !== -1}
//                               tabIndex={-1}
//                               disableRipple
//                               inputProps={{
//                                 "aria-labelledby": labelId,
//                               }}
//                             />
//                           </ListItemIcon>
//                           <ListItemText
//                             id={labelId}
//                             primary={value?.contactName}
//                           />
//                         </ListItem>
//                       );
//                     } else if (
//                       title != "User Contact List" &&
//                       pageType == "EditPage"
//                     ) {
//                       return (
//                         <ListItem
//                           key={labelId}
//                           role="listitem"
//                           button
//                           onClick={handleToggle(value)}
//                         >
//                           <ListItemIcon>
//                             <Checkbox
//                               checked={checked.indexOf(value) !== -1}
//                               tabIndex={-1}
//                               disableRipple
//                               inputProps={{
//                                 "aria-labelledby": labelId,
//                               }}
//                             />
//                           </ListItemIcon>
//                           <ListItemText
//                             id={labelId}
//                             primary={value?.contactName}
//                           />
//                         </ListItem>
//                       );
//                     } else if (title == "User Contact List") {
//                       return (
//                         <ListItem
//                           key={labelId}
//                           role="listitem"
//                           button
//                           onClick={handleToggle(value)}
//                         >
//                           <ListItemIcon>
//                             <Checkbox
//                               checked={checked.indexOf(value) !== -1}
//                               tabIndex={-1}
//                               disableRipple
//                               inputProps={{
//                                 "aria-labelledby": labelId,
//                               }}
//                             />
//                           </ListItemIcon>
//                           <ListItemText
//                             id={labelId}
//                             className="ant-transfer-list-content-item-text"
//                             primary={value?.contactName}
//                           />
//                         </ListItem>
//                       );
//                     }

//                     //       return (
//                     //         <>
//                     //           {index == 0 ? (
//                     //     <div className="row">
//                     //       <div>
//                     //         <TextField
//                     //           className=" w-100"
//                     //           style={{
//                     //             borderRadius: "4px",
//                     //           }}
//                     //           type="text"
//                     //           label="Search"
//                     //           name="phonebookDescription"
//                     //           variant="outlined"
//                     //           size="small"
//                     //           // required

//                     //           //   value={description}
//                     //           //   onChange={(event) => {
//                     //           //     setdescription(event.target.value);
//                     //           //   }}
//                     //         />
//                     //       </div>
//                     //     </div>
//                     //   ) : null}
//                     //         </>
//                     //       );
//                   })}
//               </>
//             )}
//           </List>
//         </>
//       )}
//       <Divider />
//       <div className="row justify-content-end my-2">
//         <div className="col-md-6">
//           {title == "User Contact List" ? (
//             <>
//               {data1?.totalPages ? (
//                 <div className="ms-3">
//                   {/* {width > 300 ? <span className="me-2">page:</span> : null} */}
//                   <input
//                     type="number"
//                     name=""
//                     style={{
//                       textAlign: "center",
//                       padding: "0 6px",
//                       marginLeft: "8px",
//                       width: "50px",
//                     }}
//                     id=""
//                     onChange={(e) => {
//                       if (
//                         e.target.value > 0 &&
//                         e.target.value < data1?.totalPages + 1
//                       ) {
//                         const pageNumber = e.target.value
//                           ? Number(e.target.value) - 1
//                           : 0;
//                         setPaginationState({
//                           ...paginationState,
//                           pageNumber,
//                         });
//                       }
//                     }}
//                     value={paginationState?.pageNumber + 1}
//                     // style={{ width: "50px" }}
//                   />{" "}
//                   <span class="ant-pagination-slash">/</span>{" "}
//                   {data1?.totalPages}
//                 </div>
//               ) : (
//                 <br></br>
//               )}
//             </>
//           ) : (
//             <>
//               {title != "User Contact List" && pageType == "EditPage" ? (
//                 <>
//                   {data2?.totalPages ? (
//                     <div className="ms-3">
//                       {/* {width > 300 ? <span className="me-2">page:</span> : null} */}
//                       <input
//                         type="number"
//                         name=""
//                         id=""
//                         style={{
//                           textAlign: "center",
//                           padding: "0 6px",
//                           marginLeft: "8px",
//                           width: "50px",
//                         }}
//                         onChange={(e) => {
//                           if (
//                             e.target.value > 0 &&
//                             e.target.value < data2?.totalPages + 1
//                           ) {
//                             const pageNumber = e.target.value
//                               ? Number(e.target.value) - 1
//                               : 0;
//                             setPaginationState({
//                               ...paginationState,
//                               rightPageNumber: pageNumber,
//                             });
//                           }
//                         }}
//                         value={paginationState?.rightPageNumber + 1}
//                       />{" "}
//                       / {data2?.totalPages}
//                     </div>
//                   ) : (
//                     <br></br>
//                   )}
//                 </>
//               ) : (
//                 <>
//                   {right1?.length > 0 ? (
//                     <div className="ms-3">
//                       {/* {width > 300 ? <span className="me-2">page:</span> : null} */}
//                       <input
//                         type="number"
//                         name=""
//                         id=""
//                         style={{
//                           textAlign: "center",
//                           padding: "0 6px",
//                           marginLeft: "8px",
//                           width: "50px",
//                         }}
//                         onChange={(e) => {
//                           if (
//                             e.target.value > 0 &&
//                             e.target.value < Math.ceil(right1?.length / 10) + 1
//                           ) {
//                             const pageNumber = e.target.value
//                               ? Number(e.target.value) - 1
//                               : 0;
//                             // console.log(
//                             //   "here",
//                             //   (pageNumber + 1) * paginationState.rightPageSize -
//                             //     10,

//                             //   (pageNumber + 1) * paginationState.rightPageSize
//                             // );
//                             setPaginationState({
//                               ...paginationState,
//                               rightPageNumber: pageNumber,
//                               rightPageStartIndex:
//                                 (pageNumber + 1) *
//                                   paginationState.rightPageSize -
//                                 10,
//                               rightPageEndIndex:
//                                 (pageNumber + 1) *
//                                 paginationState.rightPageSize,
//                             });
//                           }
//                         }}
//                         value={paginationState?.rightPageNumber + 1}
//                       />{" "}
//                       / {Math.ceil(right1?.length / 10)}
//                     </div>
//                   ) : (
//                     <br></br>
//                   )}
//                 </>
//               )}
//               {/* {right1?.length > 0 ? (
//                 <div className="ms-3">
                 
//                   <input
//                     type="number"
//                     name=""
//                     id=""
//                     style={{
//                       textAlign: "center",
//                       padding: "0 6px",
//                       marginLeft: "8px",
//                       width: "50px",
//                     }}
//                     onChange={(e) => {
//                       if (
//                         e.target.value > 0 &&
//                         e.target.value < Math.ceil(right1?.length / 10) + 1
//                       ) {
//                         const pageNumber = e.target.value
//                           ? Number(e.target.value) - 1
//                           : 0;
//                         console.log(
//                           "here",
//                           (pageNumber + 1) * paginationState.rightPageSize - 10,

//                           (pageNumber + 1) * paginationState.rightPageSize
//                         );
//                         setPaginationState({
//                           ...paginationState,
//                           rightPageNumber: pageNumber,
//                           rightPageStartIndex:
//                             (pageNumber + 1) * paginationState.rightPageSize -
//                             10,
//                           rightPageEndIndex:
//                             (pageNumber + 1) * paginationState.rightPageSize,
//                         });
//                       }
//                     }}
//                     value={paginationState?.rightPageNumber + 1}
//                   />{" "}
//                   / {Math.ceil(right1?.length / 10)}
//                 </div>
//               ) : null} */}
//             </>
//           )}
//         </div>
//         {/* <div className="col-md-6">
//           <div className="text-end">
//             <button>Prev</button>
//             <button>Next</button>
//           </div>
//         </div> */}
//       </div>
//     </Card>
//   );

//   useEffect(() => {
//     if (reloadReducer != "") {
//       if (pageType == "EditPage") {
//         ResetStates();
//         // ContactGetEdit();
//       } else {
//         ContactGet();
//         setRight([]);
//         setRight1([]);
//       }
//     }
//   }, [reloadReducer]);

//   return (
//     <>
//       {/* <button id="phoneBoookResetButtonId" onClick={ResetStates}>
//         Reset
//       </button> */}
//       <Grid
//         container
//         spacing={2}
//         justifyContent="center"
//         alignItems="center"
//         sx={{ padding: 0 }}
//       >
//         <Grid item>{customList("User Contact List", left)}</Grid>
//         <Grid item>
//           <div class="ant-transfer-operation">
//             <button
//               type="button"
//               onClick={handleCheckedRight}
//               disabled={leftChecked.length === 0}
//               class="ant-btn ant-btn-primary ant-btn-sm"
//             >
//               <span role="img" aria-label="right" class="anticon anticon-right">
//                 <svg
//                   viewBox="64 64 896 896"
//                   focusable="false"
//                   data-icon="right"
//                   width="1em"
//                   height="1em"
//                   fill="currentColor"
//                   aria-hidden="true"
//                 >
//                   <path d="M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z"></path>
//                 </svg>
//               </span>
//               <span>Add</span>
//             </button>
//             <button
//               type="button"
//               disabled={rightChecked.length === 0}
//               onClick={handleCheckedLeft}
//               class="ant-btn ant-btn-primary ant-btn-sm"
//             >
//               <span role="img" aria-label="left" class="anticon anticon-left">
//                 <svg
//                   viewBox="64 64 896 896"
//                   focusable="false"
//                   data-icon="left"
//                   width="1em"
//                   height="1em"
//                   fill="currentColor"
//                   aria-hidden="true"
//                 >
//                   <path d="M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z"></path>
//                 </svg>
//               </span>
//               <span>Remove</span>
//             </button>
//           </div>
//           {/* <Grid container direction="column" alignItems="center">
//             <Button
//               sx={{ my: 0.5 }}
//               variant="contained"
//               size="small"
//               onClick={handleCheckedRight}
//               disabled={leftChecked.length === 0}
//               aria-label="move selected right"
//             >
//               &gt; Add
//             </Button>
//             <Button
//               sx={{ my: 0.5 }}
//               variant="contained"
//               size="small"
//               onClick={handleCheckedLeft}
//               disabled={rightChecked.length === 0}
//               aria-label="move selected left"
//             >
//               &lt; Remove
//             </Button>
//             <button
//             disabled={leftChecked.length === 0}
//             onClick={handleCheckedRight}
//             className="ant-btn ant-btn-primary ant-btn-sm mb-2"
//           >
//             {">"} Add {"  "}
//           </button>
//           <button
//             disabled={rightChecked.length === 0}
//             onClick={handleCheckedLeft}
//             className="ant-btn ant-btn-primary ant-btn-sm"
//           >
//             {"<"} Remove
//           </button>
//           </Grid> */}
//         </Grid>
//         <Grid item>{customList("Add Contact In Phonebook", right)}</Grid>
//       </Grid>
//     </>
//   );
// }

// export default memo(TransferListTest);












import * as React from "react";
import Grid from "@mui/material/Grid";
import List from "@mui/material/List";
import Card from "@mui/material/Card";
import CardHeader from "@mui/material/CardHeader";
import ListItem from "@mui/material/ListItem";
import ListItemText from "@mui/material/ListItemText";
import ListItemIcon from "@mui/material/ListItemIcon";
import Checkbox from "@mui/material/Checkbox";
import Button from "@mui/material/Button";
import Divider from "@mui/material/Divider";
import { InputAdornment, Skeleton, TextField } from "@mui/material";
import { common_axios } from "../../../../App";
import { toast } from "react-toastify";
import { useState, memo } from "react";
import { useAsyncDebounce } from "react-table";
import SearchIcon from "@mui/icons-material/Search";
import { useEffect } from "react";
import { useSelector } from "react-redux";
import Swal from "sweetalert2";
const customId1 = "custom-id-yess";

function not(a, b) {
  return a.filter((value) => {
    return b?.indexOf(value) === -1;
  });
}

function intersection(a, b) {
  return a.filter((value) => b?.indexOf(value) !== -1);
}

function union(a, b) {
  return [...a, ...not(b, a)];
}

function TransferListTest({ onData, width, height, rightData, pageType, resetState }) {
  // const [permanentData, setPermanentData] = useState([]);

  const [checked, setChecked] = useState([]);
  const [left, setLeft] = useState([]);
  const [right, setRight] = useState([]);
  const [right1, setRight1] = useState([]);
  const [right2, setRight2] = useState([]);
  const [data1, setData1] = useState([]);
  const [data2, setData2] = useState([]);
  const [hideSkeleton, setHideSkeleton] = useState(false);
  const [paginationState, setPaginationState] = useState({
    pageNumber: 0,
    pageSize: 10,
    searchValue: "",
    searchValue1: "",
    buttonLeftToRight: false,
    rightPageNumber: 0,
    rightPageSize: 10,
    rightPageStartIndex: 0,
    rightPageEndIndex: 10,
    rightsideAddedData: null,
    leftsideAddedData: null,
    rightSideSendData: null,
    leftSideSendData: null,
  });

  const ResetStates = () => {
    setChecked([]);
    setLeft([]);
    setRight([]);
    setRight1([]);
    setRight2([]);
    setData1([]);
    setData2([]);
    setPaginationState({
      pageNumber: 0,
      pageSize: 10,
      searchValue: "",
      searchValue1: "",
      buttonLeftToRight: false,
      rightPageNumber: 0,
      rightPageSize: 10,
      rightPageStartIndex: 0,
      rightPageEndIndex: 10,
      rightsideAddedData: null,
      leftsideAddedData: null,
    });
  };

  const reloadReducer = useSelector((state) => state?.relodReducer?.relodState);

  const leftChecked = intersection(checked, left);
  const rightChecked = intersection(checked, right);

  const handleToggle = (value) => () => {
    const currentIndex = checked?.indexOf(value);
    const newChecked = [...checked];

    if (currentIndex === -1) {
      newChecked.push(value);
    } else {
      newChecked?.splice(currentIndex, 1);
    }

    setChecked(newChecked);
  };
  const onChange = useAsyncDebounce((value) => {
    setPaginationState({
      ...paginationState,
      searchValue: value,
    });
  }, 1000);
  const numberOfChecked = (items) => intersection(checked, items)?.length;

  const handleToggleAll = (items) => () => {
    if (numberOfChecked(items) === items?.length) {
      setChecked(not(checked, items));
    } else {
      setChecked(union(checked, items));
    }
  };

  const handleCheckedRight = () => {
    // for (let index1 = 0; index1 < data2?.content?.length; index1++) {
    //     const element1 = data2?.content?.[index1];
    // }

    // for (let index = 0; index < data1?.content?.length; index++) {
    //     const element = data1?.content?.[index];

    //         for (let index2 = 0; index2 < leftChecked?.length; index2++) {
    //             const element2 = leftChecked?.[index2];

    //         }

    // }
    setRight(right.concat(leftChecked));
    setRight1(right.concat(leftChecked));
    setLeft(not(left, leftChecked));
    setChecked(not(checked, leftChecked));
    let objj = paginationState.leftsideAddedData;
    let objjj1 = paginationState.leftSideSendData
      ? JSON.parse(JSON.stringify(paginationState.leftSideSendData))
      : null;
    let result2 = [];
    let result3 = [];

    // console.log({ objj }, paginationState.leftSideSendData);

    if (objj) {
      Object.keys(paginationState.leftsideAddedData)?.forEach(
        (element, index) => {
          paginationState.leftsideAddedData?.[element]?.forEach(
            (ele, indexx) => {
              leftChecked?.forEach((element1, ind) => {
                if (element1.id == ele.id) {
                  objj?.[element]?.splice(
                    indexx,
                    leftChecked.length > 0 ? leftChecked.length : 1
                  );
                }
              });
            }
          );
        }
      );
    }

    if (objjj1) {
      Object.keys(paginationState.leftSideSendData)?.forEach(
        (element, index) => {
          paginationState.leftSideSendData?.[element]?.forEach(
            (ele, indexx) => {
              leftChecked?.forEach((element1, ind) => {
                if (element1.id == ele.id) {
                  // alert("here");
                  objjj1?.[element]?.splice(
                    objjj1?.[element]?.findIndex((i) => i.id === element1.id),
                    1
                  );
                }
              });
            }
          );
        }
      );
    }

    // console.log("YYYYYYYYY", { objjj1 });

    leftChecked?.forEach((obj1) => {
      let found = false;

      data1?.content?.forEach((obj2) => {
        if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
          found = true;
        }
      });

      if (found) {
        result2.push(obj1);
      }
    });

    leftChecked?.forEach((obj1) => {
      let found = false;

      data2?.content?.forEach((obj2) => {
        if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
          found = true;
        }
      });

      if (found) {
        result3.push(obj1);
      }
    });

    // console.log(
    //   { objj, result2, leftChecked, result3 },
    //   data1?.content,
    //   paginationState.leftsideAddedData,
    //   paginationState.leftSideSendData
    // );

    // let objj1 = paginationState.leftSideSendData;
    // let objj2 = paginationState.leftSideSendData;

    // let resultLast1 = [];
    // let resultLast = [];
    // let obbbj = {};
    // Object.keys(objj2)?.forEach((element, index) => {
    //   console.log("first0");

    //   objj2?.[element]?.forEach((ele, indexx) => {
    //     console.log("first1");
    //     leftChecked?.forEach(async (element1, ind) => {
    //       console.log("first", element1, ele);
    //       if (paginationState.pageNumber != element) {
    //         console.log("second");
    //         if (element1.id == ele.id) {
    //           if (!obbbj?.[index]) {
    //             obbbj[index] = 0;
    //           }

    //           console.log(
    //             "third",
    //             { element1, ele, indexx, objj1, obbbj },
    //             objj1?.[element]?.findIndex((i) => i.id === element1.id)
    //           );
    //           await objj1?.[element]?.splice(
    //             // indexx - obbbj[index],
    //             objj1?.[element]?.findIndex((i) => i.id === element1.id),
    //             1
    //             //   leftChecked.length > 0 ? leftChecked.length : 1
    //           );
    //           obbbj[index] = obbbj[index] + 1;
    //         }
    //       } else if (paginationState.pageNumber == element) {
    //         console.log("second1");
    //         const result1 = [];
    //         const result2 = [];
    //         objj1?.[element]?.forEach(async (obj1) => {
    //           let found = false;

    //           leftChecked?.forEach(async (obj2) => {
    //             if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
    //               found = true;
    //             }
    //           });
    //           // data2?.content?.forEach(async (obj2) => {
    //           //   if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
    //           //     found = true;
    //           //   }
    //           // });

    //           if (!found) {
    //             console.log("HHHHHHH", objj1?.[element]);
    //             //   alert("here");
    //             objj1?.[element]?.splice(
    //               // indexx - obbbj[index],
    //               objj1?.[element]?.findIndex((i) => i.id === element1.id),
    //               1
    //               //   leftChecked.length > 0 ? leftChecked.length : 1
    //             );
    //             result1.push(obj1);
    //           }
    //         });

    //         leftChecked?.forEach((obj1) => {
    //           let found = false;

    //           data2?.content?.forEach((obj2) => {
    //             if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
    //               found = true;
    //             }
    //           });

    //           if (found) {
    //             result2.push(obj1);
    //           }
    //         });

    //         if (leftChecked?.length - 1 == ind) {
    //           resultLast = result1;
    //           resultLast1 = result2;
    //         }

    //         console.log("UUUUUUU", result1, result2);
    //       }
    //     });
    //   });
    // });

    let vall = {
      ...paginationState.rightSideSendData,
      [paginationState.pageNumber]: paginationState.rightSideSendData?.[
        paginationState.pageNumber
      ]
        ? [
            ...paginationState.rightSideSendData?.[paginationState.pageNumber],
            ...leftChecked,
          ]
        : leftChecked,
    };

    localStorage.setItem("phonebookrightSideSendData", JSON.stringify(vall));
    // localStorage.setItem("phonebookrightSideSendData", JSON.stringify(objjj1));

    setPaginationState({
      ...paginationState,
      buttonLeftToRight: true,
      //   leftsideAddedData: {
      //     ...paginationState.leftsideAddedData,
      //     [paginationState.pageNumber]: leftChecked,
      //   },
      rightsideAddedData: {
        ...paginationState.rightsideAddedData,
        [paginationState.rightPageNumber]: paginationState.rightsideAddedData?.[
          paginationState.rightPageNumber
        ]
          ? [
              ...paginationState.rightsideAddedData?.[
                paginationState.rightPageNumber
              ],
              ...leftChecked,
            ]
          : leftChecked,
      },
      rightSideSendData: {
        ...paginationState.rightSideSendData,
        [paginationState.pageNumber]: paginationState.rightSideSendData?.[
          paginationState.pageNumber
        ]
          ? [
              ...paginationState.rightSideSendData?.[
                paginationState.pageNumber
              ],
              ...result2,
            ]
          : result2,
      },
      leftsideAddedData: objj,
      leftSideSendData: objjj1,
    });

    // const result1 = [];
    // leftChecked?.forEach((obj1) => {
    //   let found = false;

    //   data2?.content?.forEach((obj2) => {
    //     if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
    //       found = true;
    //     }
    //   });

    //   if (!found) {
    //     result1.push(obj1);
    //   }
    // });

    // paginationState.leftsideAddedData?.[0]?.forEach((ele, indexx) => {
    //     leftChecked?.forEach((element1, ind) => {
    //       if (element1.id == ele.id) {
    //         objj?.[0]?.splice(
    //           indexx,
    //           leftChecked.length > 0 ? leftChecked.length : 1
    //         );
    //       }
    //     });
    //   });

    // paginationState.leftsideAddedData?.[0]?.forEach((ele, indexx) => {
    //   result1?.forEach((element1, ind) => {
    //     if (element1.id == ele.id) {
    //       objj?.[0]?.splice(indexx, result1.length > 0 ? result1.length : 1);
    //     }
    //   });
    // });

    // setPaginationState({
    //   ...paginationState,
    //   buttonLeftToRight: true,
    //   //   leftsideAddedData: {
    //   //     ...paginationState.leftsideAddedData,
    //   //     [paginationState.pageNumber]: leftChecked,
    //   //   },
    //   rightsideAddedData: {
    //     ...paginationState.rightsideAddedData,
    //     [0]: paginationState.rightsideAddedData?.[0]
    //       ? [...paginationState.rightsideAddedData?.[0], ...leftChecked]
    //       : leftChecked,
    //   },
    //   leftsideAddedData: objj,
    // });
  };

  const handleCheckedLeft = () => {
    setLeft(left.concat(rightChecked));
    setRight(not(right, rightChecked));
    setRight1(not(right, rightChecked));
    setChecked(not(checked, rightChecked));
    let objj = paginationState.rightsideAddedData;
    if (objj) {
      Object.keys(paginationState.rightsideAddedData)?.forEach(
        (element, index) => {
          paginationState.rightsideAddedData?.[element]?.forEach(
            (ele, indexx) => {
              rightChecked?.forEach((element1, ind) => {
                if (element1.id == ele.id) {
                  objj?.[element]?.splice(
                    indexx,
                    rightChecked.length > 0 ? rightChecked.length : 1
                  );
                }
              });
            }
          );
        }
      );
    }

    // let objj1 = JSON.parse(localStorage.getItem("phonebookrightSideSendData"));
    // let objj2 = JSON.parse(localStorage.getItem("phonebookrightSideSendData"));
    // let objj1 =
    //   paginationState.rightSideSendData?.[paginationState.pageNumber]?.length >
    //   0
    //     ? JSON.parse(JSON.stringify(paginationState.rightSideSendData))
    //     : null;
    // let objj2 =
    //   paginationState.rightSideSendData?.[paginationState.pageNumber]?.length >
    //   0
    //     ? JSON.parse(JSON.stringify(paginationState.rightSideSendData))
    //     : null;

    let obr = {};
    if (paginationState.rightSideSendData) {
      Object.keys(paginationState.rightSideSendData)?.forEach(
        (keysLoop, index) => {
          paginationState.rightSideSendData?.[keysLoop]?.forEach(
            (keysValue, index1) => {
              // console.log({ keysValue });
              if (keysValue?.length > 0) {
                // alert("here");
                obr[keysLoop] = keysValue;
              }
            }
          );
        }
      );
    }

    // let objj1 =
    //   paginationState.rightSideSendData?.[paginationState.pageNumber]?.length >
    //   0
    //     ? JSON.parse(JSON.stringify(paginationState.rightSideSendData))
    //     : null;
    // let objj2 =
    //   paginationState.rightSideSendData?.[paginationState.pageNumber]?.length >
    //   0
    //     ? JSON.parse(JSON.stringify(paginationState.rightSideSendData))
    //     : null;

    let objj1 = paginationState.rightSideSendData
      ? Object.keys(paginationState.rightSideSendData).some((dataaa) => {
          // console.log(paginationState.rightSideSendData?.[dataaa]?.length);
          return paginationState.rightSideSendData?.[dataaa]?.length > 0;
        }) == true
        ? paginationState.rightSideSendData
        : null
      : null;
    let objj2 = paginationState.rightSideSendData
      ? Object.keys(paginationState.rightSideSendData).some((dataaa) => {
          // console.log(paginationState.rightSideSendData?.[dataaa]?.length);
          return paginationState.rightSideSendData?.[dataaa]?.length > 0;
        }) == true
        ? paginationState.rightSideSendData
        : null
      : null;

    // console.log(
    //   "TTTTTTT",
    //   { objj2, rightChecked, data1, data2, objj1, obr },
    //   paginationState.leftSideSendData,
    //   paginationState.rightSideSendData,

    //   paginationState.rightSideSendData
    //     ? Object.keys(paginationState.rightSideSendData).some((dataaa) => {
    //         console.log(paginationState.rightSideSendData?.[dataaa]?.length);
    //         return paginationState.rightSideSendData?.[dataaa]?.length > 0;
    //       }) == true
    //       ? paginationState.rightSideSendData
    //       : null
    //     : null
    // );
    let obbbj = {};
    // Object.keys(objj2)?.forEach((element, index) => {
    //   console.log("first0");
    //   objj2?.[element]?.forEach((ele, indexx) => {
    //     console.log("first1");
    //     rightChecked?.forEach(async (element1, ind) => {
    //       console.log("first", element1, ele);
    //       if (paginationState.pageNumber != element) {
    //         console.log("second");
    //         if (element1.id == ele.id) {
    //           if (!obbbj?.[index]) {
    //             obbbj[index] = 0;
    //           }

    //           console.log(
    //             "third",
    //             { element1, ele, indexx, objj1, obbbj },
    //             objj1?.[element]?.findIndex((i) => i.id === element1.id)
    //           );
    //           await objj1?.[element]?.splice(
    //             // indexx - obbbj[index],
    //             objj1?.[element]?.findIndex((i) => i.id === element1.id),
    //             1
    //             //   rightChecked.length > 0 ? rightChecked.length : 1
    //           );
    //           obbbj[index] = obbbj[index] + 1;
    //         }
    //       } else if (paginationState.pageNumber == element) {
    //         const result1 = [];
    //         objj1?.[element]?.forEach((obj1) => {
    //           let found = false;

    //           data1?.content?.forEach((obj2) => {
    //             if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
    //               found = true;
    //             }
    //           });

    //           if (found) {
    //             result1.push(obj1);
    //           }
    //         });

    //         console.log("UUUUUUU", result1);
    //       }
    //     });
    //   });
    // });
    let resultLast = [];
    let resultLast1 = [];

    if (objj2?.[paginationState.pageNumber]) {
      Object.keys(objj2)?.forEach((element, index) => {
        // console.log("first0");

        objj2?.[element]?.forEach((ele, indexx) => {
          // console.log("first1");
          rightChecked?.forEach(async (element1, ind) => {
            console.log("first", element1, ele);
            if (paginationState.pageNumber != element) {
              // console.log("second");
              if (element1.id == ele.id) {
                if (!obbbj?.[index]) {
                  obbbj[index] = 0;
                }

                // console.log(
                //   "third",
                //   { element1, ele, indexx, objj1, obbbj },
                //   objj1?.[element]?.findIndex((i) => i.id === element1.id)
                // );
                await objj1?.[element]?.splice(
                  // indexx - obbbj[index],
                  objj1?.[element]?.findIndex((i) => i.id === element1.id),
                  1
                  //   rightChecked.length > 0 ? rightChecked.length : 1
                );
                obbbj[index] = obbbj[index] + 1;
              }
            } else if (paginationState.pageNumber == element) {
              // console.log("second1");
              const result1 = [];
              const result2 = [];
              objj1?.[element]?.forEach(async (obj1) => {
                let found = false;

                data1?.content?.forEach(async (obj2) => {
                  rightChecked?.forEach((obj3) => {
                    if (
                      JSON.stringify(obj1) === JSON.stringify(obj2) &&
                      JSON.stringify(obj1) === JSON.stringify(obj3) &&
                      JSON.stringify(obj2) === JSON.stringify(obj3)
                    ) {
                      found = true;
                    }
                  });
                });

                if (found) {
                  // console.log("HHHHHHH", objj1?.[element]);
                  //   alert("here");
                  objj1?.[element]?.splice(
                    // indexx - obbbj[index],
                    objj1?.[element]?.findIndex((i) => i.id === element1.id),
                    1
                    //   rightChecked.length > 0 ? rightChecked.length : 1
                  );
                  result1.push(obj1);
                }
              });
              rightChecked?.forEach((obj1) => {
                let found = false;

                data2?.content?.forEach((obj2) => {
                  if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
                    found = true;
                  }
                });

                if (found) {
                  result2.push(obj1);
                }
              });

              if (rightChecked?.length - 1 == ind) {
                resultLast = result1;
                resultLast1 = result2;
              }

              // console.log("UUUUUUU", result1, result2);
            }
          });
        });
      });
    } else {
      rightChecked?.forEach((obj1) => {
        let found = false;

        data2?.content?.forEach((obj2) => {
          // console.log("BBBBBBBBBB", obj1, obj2, rightChecked, data2?.content);
          if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
            found = true;
          }
        });

        if (found) {
          resultLast1.push(obj1);
        }
      });
    }

    // rightChecked?.forEach((obj1) => {
    //   let found = false;

    //   data2?.content?.forEach((obj2) => {
    //     if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
    //       found = true;
    //     }
    //   });

    //   if (found) {
    //     resultLast.push(obj1);
    //   }
    // });

    // console.log(
    //   { objj1, objj2, resultLast, resultLast1 },
    //   paginationState.leftSideSendData?.[paginationState.rightPageNumber]
    // );

    setPaginationState({
      ...paginationState,
      leftsideAddedData: {
        ...paginationState.leftsideAddedData,
        [paginationState.pageNumber]:
          resultLast?.length > 0 ? resultLast : rightChecked,
      },
      //   leftsideAddedData: {
      //     ...paginationState.leftsideAddedData,
      //     [paginationState.pageNumber]: paginationState.leftsideAddedData?.[
      //       paginationState.pageNumber
      //     ]
      //       ? [
      //           ...paginationState.leftsideAddedData?.[
      //             paginationState.pageNumber
      //           ],
      //           ...rightChecked,
      //         ]
      //       : rightChecked,
      //   },
      //   leftSideSendData: {
      //     ...paginationState.leftSideSendData,
      //     [paginationState.rightPageNumber]: paginationState.leftSideSendData?.[
      //       paginationState.rightPageNumber
      //     ]
      //       ? [
      //           ...paginationState.leftSideSendData?.[
      //             paginationState.rightPageNumber
      //           ],
      //           ...leftChecked,
      //         ]
      //       : leftChecked,
      //   },
      leftSideSendData: {
        ...paginationState.leftSideSendData,
        [paginationState.rightPageNumber]: paginationState.leftSideSendData?.[
          paginationState.rightPageNumber
        ]
          ? [
              ...paginationState.leftSideSendData?.[
                paginationState.rightPageNumber
              ],
              ...resultLast1,
            ]
          : resultLast1?.length > 0
          ? resultLast1
          : // : rightChecked,
            resultLast1,
        //    rightChecked
      },

      rightsideAddedData: objj,
      rightSideSendData: objj1,
      //   rightsideAddedData: {
      //     ...paginationState.rightsideAddedData,
      //     [paginationState.pageNumber]: rightChecked,
      //   },
    });

    localStorage.setItem("phonebookrightSideSendData", JSON.stringify(objj1));

    // console.log({ objj });

    // paginationState.rightsideAddedData?.[0]?.forEach((ele, indexx) => {
    //     rightChecked?.forEach((element1, ind) => {
    //       if (element1.id == ele.id) {
    //         objj?.[0]?.splice(
    //           indexx,
    //           rightChecked.length > 0 ? rightChecked.length : 1
    //         );
    //       }
    //     });
    //   });

    // setPaginationState({
    //     ...paginationState,
    //     leftsideAddedData: {
    //       ...paginationState.leftsideAddedData,
    //       [0]: paginationState.leftsideAddedData?.[0]
    //         ? [...paginationState.leftsideAddedData?.[0], ...rightChecked]
    //         : rightChecked,
    //     },
    //     rightsideAddedData: objj,
    //     //   rightsideAddedData: {
    //     //     ...paginationState.rightsideAddedData,
    //     //     [paginationState.pageNumber]: rightChecked,
    //     //   },
    //   });
  };

  async function ContactGet(values) {
    if (paginationState?.searchValue == "") {
      try {
        setHideSkeleton(true);
        const res = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/user-contacts/v2/list`,
          {
            pagination: {
              pageNo: paginationState.pageNumber,
              pageSize: paginationState.pageSize,
            },
          }
        );
        if (res.data.statusdescription.statusCode == 200) {
          setHideSkeleton(false);
          setLeft();
          if (res.data?.page?.content) {
            setData1(res.data.page);
            // setPermanentData(res.data.page)
            const result = [];

            res.data?.page?.content.forEach((obj1) => {
              let found = false;

              right1.forEach((obj2) => {
                if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
                  found = true;
                }
              });

              if (!found) {
                result.push(obj1);
              }
            });
            setLeft(result);
          }
        } else {
          setHideSkeleton(false);
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusdescription.statusDescription,
          });
        }
      } catch (error) {
        setHideSkeleton(false);
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Please Check Your Network",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } else {
      try {
        setHideSkeleton(true);
        const res = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/v1/search/contact`,
          {
            pagination: {
              pageNo: paginationState.pageNumber,
              pageSize: paginationState.pageSize,
            },
            msisdn: null,
            contactName: paginationState?.searchValue,
          }
        );
        if (res.data.statusdescription.statusCode == 200) {
          setHideSkeleton(false);
          setLeft();
          if (res.data?.page?.content) {
            setData1(res.data.page);
            setLeft(res.data?.page?.content);
          }
        } else {
          setHideSkeleton(false);
          // toast.error(res.data.statusdescription.statusDescription, {
          //   toastId: customId1,
          // });
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusdescription.statusDescription,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      } catch (error) {
        setHideSkeleton(false);

        // toast.error("Please Check Your Network", {
        //   toastId: customId1,
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Please Check Your Network",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    }
  }

  useEffect(() => {
    setRight([]);
    setRight1([]);
    setRight2([]);
    // if (permanentArray?.length > 0) {
    //   setTimeout(() => {
    //     setLeft(permanentArray);
    //   }, 100);
    // }
  }, [resetState]);
  async function ContactGetEdit(values) {
    if (paginationState?.searchValue == "") {
      try {
        setHideSkeleton(true);
        let res = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/v1/get/phoneBook/user-contacts`,
          {
            pagination: {
              pageNo: paginationState.pageNumber,
              pageSize: paginationState.pageSize,
              rightSidePageSize: paginationState.rightPageSize,
              rightSidePageNo: paginationState.rightPageNumber,
            },
            phoneBookId: rightData?.id,
          }
        );
        if (res.data.statusdescription.statusCode == 200) {
          setHideSkeleton(false);

          // setData1(res.data.page);
          //   const result = [];
          //   res.data?.page?.content.forEach((obj1) => {
          //     let found = false;
          //     right1.forEach((obj2) => {
          //       if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
          //         found = true;
          //       }
          //     });
          //     if (!found) {
          //       result.push(obj1);
          //     }
          //   });
          //   console.log({ result });

          //   if (
          //     pageType == "EditPage" &&
          //     (paginationState?.leftsideAddedData?.[
          //       paginationState?.pageNumber
          //     ] ||
          //       paginationState?.rightsideAddedData?.[
          //         paginationState?.rightPageNumber
          //       ])
          //   ) {
          if (pageType == "EditPage") {
            // alert("In main");
            let leftArr = res.data?.leftUsers?.content;
            let rightArr = res.data?.righUser?.content;
            if (paginationState?.leftsideAddedData) {
              //   alert("here");
              // console.log(
              //   "OOOOOO",
              //   paginationState?.leftsideAddedData?.[
              //     paginationState?.pageNumber
              //   ]
              // );

              if (
                paginationState?.leftsideAddedData?.[
                  paginationState?.pageNumber
                ]
              ) {
                // alert("here up");

                const result1 = [];
                res.data?.leftUsers?.content?.forEach((obj1) => {
                  let found = false;
                  Object.keys(paginationState?.leftsideAddedData)?.forEach(
                    (dddata, index) => {
                      // console.log({ dddata });

                      paginationState?.leftsideAddedData?.[dddata]?.forEach(
                        (obj2) => {
                          if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
                            found = true;
                          }
                        }
                      );
                    }
                  );

                  if (!found) {
                    result1.push(obj1);
                  }
                });

                // console.log("WWWWWW", result1);

                // leftArr = res.data?.leftUsers?.content.concat(
                //   paginationState?.leftsideAddedData?.[
                //     paginationState?.pageNumber
                //   ]
                // );
                leftArr = result1.concat(
                  paginationState?.leftsideAddedData?.[
                    paginationState?.pageNumber
                  ]
                );
              } else {
                leftArr = res.data?.leftUsers?.content;
              }

              let result = [];

              let result1 = [];
              let result2 = [];
              // res.data?.righUser?.content?.forEach((obj1) => {
              //   let found = false;
              //   paginationState?.leftsideAddedData?.[
              //     paginationState?.pageNumber
              //   ]?.forEach((obj2) => {
              //     if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
              //       found = true;
              //     }
              //   });
              //   if (!found) {
              //     result.push(obj1);
              //   }
              // });

              //   res.data?.righUser?.content?.forEach((obj1) => {
              //     let found = false;

              //     paginationState?.leftsideAddedData?.[0]?.forEach((obj2) => {
              //       if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
              //         found = true;
              //       }
              //     });

              //     if (!found) {
              //       result1.push(obj1);
              //     }
              //   });

              res.data?.righUser?.content?.forEach((obj1) => {
                let found = false;
                Object.keys(paginationState?.leftsideAddedData)?.forEach(
                  (dddata, index) => {
                    // console.log(":::::::", { dddata });

                    paginationState?.leftsideAddedData?.[dddata]?.forEach(
                      (obj2) => {
                        if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
                          found = true;
                        }
                      }
                    );
                  }
                );

                if (!found) {
                  result1.push(obj1);
                }
              });

              // console.log("here", result1, paginationState?.rightsideAddedData);

              //   result1?.forEach((obj1) => {
              //     let found = false;

              //     paginationState?.rightsideAddedData?.[0]?.forEach((obj2) => {
              //       if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
              //         found = true;
              //       }
              //     });

              //     if (!found) {
              //       result2.push(obj1);
              //     }
              //   });
              if (paginationState?.rightsideAddedData) {
                result1?.forEach((obj1) => {
                  let found = false;
                  Object.keys(paginationState?.rightsideAddedData)?.forEach(
                    (dddata, index) => {
                      // console.log(";;;;;;;;;", { dddata });

                      paginationState?.rightsideAddedData?.[dddata]?.forEach(
                        (obj2) => {
                          if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
                            found = true;
                          }
                        }
                      );
                    }
                  );

                  if (!found) {
                    result2.push(obj1);
                  }
                });
              } else {
                result2 = result1;
              }

              // console.log({ result, result1, result2 });
              rightArr = result2;
            }

            if (
              paginationState?.rightsideAddedData &&
              res.data?.leftUsers?.content &&
              res.data?.righUser?.content
            ) {
              //   alert("now");
              // console.log(
              //   "PPPPPP",
              //   paginationState?.rightsideAddedData?.[
              //     paginationState?.rightPageNumber
              //   ]
              // );
              //   if (rightArr?.length > 0) {

              if (
                paginationState?.rightsideAddedData?.[
                  paginationState?.rightPageNumber
                ]
              ) {
                rightArr = rightArr.concat(
                  paginationState?.rightsideAddedData?.[
                    paginationState?.rightPageNumber
                  ]
                );
              }
              // paginationState?.rightsideAddedData?.[
              //   paginationState?.rightPageNumber
              // ]
              //   ? (rightArr = rightArr.concat(
              //       paginationState?.rightsideAddedData?.[
              //         paginationState?.rightPageNumber
              //       ]
              //     ))
              //   : (rightArr = rightArr);
              //   } else {
              //     paginationState?.rightsideAddedData?.[
              //       paginationState?.rightPageNumber
              //     ]
              //       ? (rightArr = res.data?.righUser?.content.concat(
              //           paginationState?.rightsideAddedData?.[
              //             paginationState?.rightPageNumber
              //           ]
              //         ))
              //       : (rightArr = res.data?.righUser?.content);
              //   }
              //   setRight(
              //     res.data?.righUser?.content.concat(
              //       paginationState?.rightsideAddedData?.[
              //         paginationState?.rightPageNumber
              //       ]
              //     )
              //   );
              const result = [];
              const result1 = [];
              if (leftArr?.length > 0) {
                // leftArr?.forEach((obj1) => {
                //   let found = false;
                //   paginationState?.rightsideAddedData?.[
                //     paginationState?.rightPageNumber
                //   ]?.forEach((obj2) => {
                //     if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
                //       found = true;
                //     }
                //   });
                //   if (!found) {
                //     result.push(obj1);
                //   }
                // });

                // leftArr?.forEach((obj1) => {
                //   let found = false;
                //   //   Object.keys(paginationState?.rightsideAddedData)?.forEach(
                //   //     (dddata, index) => {

                //   paginationState?.rightsideAddedData?.[0]?.forEach((obj2) => {
                //     if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
                //       found = true;
                //     }
                //   });
                //   //     }
                //   //   );

                //   if (!found) {
                //     result1.push(obj1);
                //   }
                // });

                leftArr?.forEach((obj1) => {
                  let found = false;
                  Object.keys(paginationState?.rightsideAddedData)?.forEach(
                    (dddata, index) => {
                      // console.log({ dddata });

                      paginationState?.rightsideAddedData?.[dddata]?.forEach(
                        (obj2) => {
                          if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
                            found = true;
                          }
                        }
                      );
                    }
                  );

                  if (!found) {
                    result1.push(obj1);
                  }
                });
              } else {
                // res.data?.leftUsers?.content.forEach((obj1) => {
                //   let found = false;
                //   paginationState?.rightsideAddedData?.[
                //     paginationState?.rightPageNumber
                //   ]?.forEach((obj2) => {
                //     if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
                //       found = true;
                //     }
                //   });
                //   if (!found) {
                //     result.push(obj1);
                //   }
                // });

                // res.data?.leftUsers?.content?.forEach((obj1) => {
                //   let found = false;

                //   paginationState?.rightsideAddedData?.[0]?.forEach((obj2) => {
                //     if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
                //       found = true;
                //     }
                //   });

                //   if (!found) {
                //     result1.push(obj1);
                //   }
                // });

                res.data?.leftUsers?.content?.forEach((obj1) => {
                  let found = false;
                  Object.keys(paginationState?.rightsideAddedData)?.forEach(
                    (dddata, index) => {
                      // console.log({ dddata });

                      paginationState?.rightsideAddedData?.[dddata]?.forEach(
                        (obj2) => {
                          if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
                            found = true;
                          }
                        }
                      );
                    }
                  );

                  if (!found) {
                    result1.push(obj1);
                  }
                });
              }
              // console.log({ result, result1 });
              leftArr = result1;
              //   setLeft(result);
              // setLeft(
              //   not(
              //     res.data?.leftUsers?.content,
              //     paginationState?.rightsideAddedData?.[
              //       paginationState?.rightPageNumber
              //     ]
              //   )
              // );
            }
            // console.log({ leftArr, rightArr });
            setLeft(leftArr);
            setRight(rightArr);
            setRight1(rightArr);
            setRight2(rightArr);
            if (res.data?.leftUsers?.content) {
              setData1(res.data.leftUsers);
            }
            if (res.data?.righUser?.content) {
              setData2(res.data?.righUser);
            }
          } else {
            if (res.data?.leftUsers?.content) {
              setData1(res.data.leftUsers);
              setLeft(res.data?.leftUsers?.content);
            }
            if (res.data?.righUser?.content) {
              setData2(res.data?.righUser);
              setRight(res.data?.righUser?.content);
              setRight1(res.data?.righUser?.content);
              setRight2(res.data?.righUser?.content);
            }
          }
        } else {
          setHideSkeleton(false);
          // toast.error(res.data.statusdescription.statusDescription, {
          //   toastId: customId1,
          // });
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusdescription.statusDescription,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      } catch (error) {
        setHideSkeleton(false);
        // console.log({ error });
        // toast.error("Please Check Your Network", {
        //   toastId: customId1,
        // });
        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Please Check Your Network",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    } else {
      //   try {
      //     setHideSkeleton(true);
      //     const res = await common_axios.post(
      //       `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/v1/search/contact`,
      //       {
      //         pagination: {
      //           pageNo: paginationState.pageNumber,
      //           pageSize: paginationState.pageSize,
      //         },
      //         msisdn: null,
      //         contactName: paginationState?.searchValue,
      //       }
      //     );
      //     if (res.data.statusdescription.statusCode == 200) {
      //       setHideSkeleton(false);
      //       setLeft();
      //       if (res.data?.page?.content) {
      //         setData1(res.data.page);
      //         setLeft(res.data?.page?.content);
      //       }
      //     } else {
      //       setHideSkeleton(false);
      //       toast.error(res.data.statusdescription.statusDescription, {
      //         toastId: customId1,
      //       });
      //     }
      //   } catch (error) {
      //     setHideSkeleton(false);
      //     toast.error("Please Check Your Network", {
      //       toastId: customId1,
      //     });
      //   }

      try {
        setHideSkeleton(true);
        let res = await common_axios.post(
          `${process.env.REACT_APP_COMMON_API_PHONEBOOKCONTACTS}/user/v1/search/phoneBook/user-contacts`,
          {
            pagination: {
              pageNo: paginationState.pageNumber,
              pageSize: paginationState.pageSize,
              rightSidePageSize: paginationState.rightPageSize,
              rightSidePageNo: paginationState.rightPageNumber,
            },
            phoneBookId: rightData?.id,
            contactName: paginationState?.searchValue,
          }
        );
        if (res.data.statusdescription.statusCode == 200) {
          setHideSkeleton(false);

          // setData1(res.data.page);
          //   const result = [];
          //   res.data?.page?.content.forEach((obj1) => {
          //     let found = false;
          //     right1.forEach((obj2) => {
          //       if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
          //         found = true;
          //       }
          //     });
          //     if (!found) {
          //       result.push(obj1);
          //     }
          //   });
          //   console.log({ result });

          //   if (
          //     pageType == "EditPage" &&
          //     (paginationState?.leftsideAddedData?.[
          //       paginationState?.pageNumber
          //     ] ||
          //       paginationState?.rightsideAddedData?.[
          //         paginationState?.rightPageNumber
          //       ])
          //   ) {
          if (pageType == "EditPage") {
            // alert("In main");
            let leftArr = res.data?.leftUsers?.content;
            let rightArr = res.data?.righUser?.content;
            if (paginationState?.leftsideAddedData) {
              //   alert("here");
              // console.log(
              //   "OOOOOO",
              //   paginationState?.leftsideAddedData?.[
              //     paginationState?.pageNumber
              //   ]
              // );

              if (
                paginationState?.leftsideAddedData?.[
                  paginationState?.pageNumber
                ]
              ) {
                const result1 = [];
                // res.data?.leftUsers?.content?.forEach((obj1) => {
                //   let found = false;

                //   paginationState?.leftsideAddedData?.[0]?.forEach((obj2) => {
                //     if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
                //       found = true;
                //     }
                //   });

                //   if (!found) {
                //     result1.push(obj1);
                //   }
                // });

                res.data?.leftUsers?.content?.forEach((obj1) => {
                  let found = false;
                  Object.keys(paginationState?.leftsideAddedData)?.forEach(
                    (dddata, index) => {
                      // console.log({ dddata });

                      paginationState?.leftsideAddedData?.[dddata]?.forEach(
                        (obj2) => {
                          if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
                            found = true;
                          }
                        }
                      );
                    }
                  );

                  if (!found) {
                    result1.push(obj1);
                  }
                });

                // leftArr = result1; // don`t add left side moved data and filter data remove which are removed from left

                leftArr = result1.concat(
                  paginationState?.leftsideAddedData?.[ //  add left side moved data and filter data remove which are removed from left
                    paginationState?.pageNumber
                  ]
                    ?.filter(
                      (ddd, index) =>
                        ddd?.contactName
                          ?.toLowerCase()
                          ?.includes(
                            paginationState?.searchValue?.toLowerCase()
                          ) // now filtering data based on input
                    )
                );

                // leftArr = res.data?.leftUsers?.content.concat( //  add left side moved data
                //   paginationState?.leftsideAddedData?.[
                //     paginationState?.pageNumber
                //   ]
                // );
              } else {
                leftArr = res.data?.leftUsers?.content;
              }

              const result = [];
              //   res.data?.righUser?.content?.forEach((obj1) => {
              //     let found = false;
              //     paginationState?.leftsideAddedData?.[
              //       paginationState?.pageNumber
              //     ]?.forEach((obj2) => {
              //       if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
              //         found = true;
              //       }
              //     });
              //     if (!found) {
              //       result.push(obj1);
              //     }
              //   });

              const result1 = [];
              //   res.data?.righUser?.content?.forEach((obj1) => {
              //     let found = false;

              //     paginationState?.leftsideAddedData?.[0]?.forEach((obj2) => {
              //       if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
              //         found = true;
              //       }
              //     });

              //     if (!found) {
              //       result1.push(obj1);
              //     }
              //   });

              res.data?.righUser?.content?.forEach((obj1) => {
                let found = false;
                Object.keys(paginationState?.leftsideAddedData)?.forEach(
                  (dddata, index) => {
                    // console.log({ dddata });

                    paginationState?.leftsideAddedData?.[dddata]?.forEach(
                      (obj2) => {
                        if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
                          found = true;
                        }
                      }
                    );
                  }
                );

                if (!found) {
                  result1.push(obj1);
                }
              });

              // console.log({ result, result1 });
              rightArr = result1;
            }

            if (
              paginationState?.rightsideAddedData &&
              res.data?.righUser?.content
              //   res.data?.leftUsers?.content &&
            ) {
              //   alert("now");
              // console.log(
              //   "PPPPPP",
              //   paginationState?.rightsideAddedData?.[
              //     paginationState?.rightPageNumber
              //   ]
              // );
              //   if (rightArr?.length > 0) {
              // alert("if");

              const result2 = [];
              //   rightArr?.forEach((obj1) => {
              //     let found = false;

              //     paginationState?.rightsideAddedData?.[0]?.forEach((obj2) => {
              //       if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
              //         found = true;
              //       }
              //     });

              //     if (!found) {
              //       result2.push(obj1);
              //     }
              //   });

              rightArr?.forEach((obj1) => {
                let found = false;
                Object.keys(paginationState?.rightsideAddedData)?.forEach(
                  (dddata, index) => {
                    // console.log({ dddata });

                    paginationState?.rightsideAddedData?.[dddata]?.forEach(
                      (obj2) => {
                        if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
                          found = true;
                        }
                      }
                    );
                  }
                );

                if (!found) {
                  result2.push(obj1);
                }
              });

              // console.log("LLLLLLLL", { result2 });
              rightArr = result2;

              // console.log(
              //   "KKKKKKKK",
              //   rightArr.concat(
              //     paginationState?.rightsideAddedData?.[
              //       paginationState?.rightPageNumber
              //     ]
              //   )
              // );

              //   paginationState?.rightsideAddedData?.[
              //     paginationState?.rightPageNumber
              //   ]
              //     ? alert("here good")(
              //         (rightArr = rightArr.concat(
              //           paginationState?.rightsideAddedData?.[
              //             paginationState?.rightPageNumber
              //           ]
              //         ))
              //       )
              //     : alert("here bad")((rightArr = rightArr));

              if (
                paginationState?.rightsideAddedData?.[
                  paginationState?.rightPageNumber
                ]
              ) {
                rightArr = rightArr.concat(
                  paginationState?.rightsideAddedData?.[
                    paginationState?.rightPageNumber
                  ]?.filter(
                    (ddd, index) =>
                      ddd?.contactName
                        ?.toLowerCase()
                        ?.includes(paginationState?.searchValue?.toLowerCase()) // now filtering data based on input
                  )
                );
              }

              // console.log("TTTTTTTT", rightArr);
              //   }
              //   else {
              //     alert("else");

              //     const result1 = [];
              //     res.data?.righUser?.content?.forEach((obj1) => {
              //       let found = false;
              //       Object.keys(paginationState?.leftsideAddedData)?.forEach(
              //         (dddata, index) => {
              //           console.log({ dddata });

              //           paginationState?.leftsideAddedData?.[dddata]?.forEach(
              //             (obj2) => {
              //               if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
              //                 found = true;
              //               }
              //             }
              //           );
              //         }
              //       );

              //       if (!found) {
              //         result1.push(obj1);
              //       }
              //     });

              //     console.log("LLLLLLLL", { result1 });

              //     rightArr = result1;

              //     // paginationState?.rightsideAddedData?.[
              //     //   paginationState?.rightPageNumber
              //     // ]
              //     //   ? (rightArr = result1.concat(
              //     //       paginationState?.rightsideAddedData?.[
              //     //         paginationState?.rightPageNumber
              //     //       ]
              //     //     ))
              //     //   : (rightArr = result1);

              //     // paginationState?.rightsideAddedData?.[
              //     //   paginationState?.rightPageNumber
              //     // ]
              //     //   ? (rightArr = res.data?.righUser?.content.concat(
              //     //       paginationState?.rightsideAddedData?.[
              //     //         paginationState?.rightPageNumber
              //     //       ]
              //     //     ))
              //     //   : (rightArr = res.data?.righUser?.content);
              //   }
              //   setRight(
              //     res.data?.righUser?.content.concat(
              //       paginationState?.rightsideAddedData?.[
              //         paginationState?.rightPageNumber
              //       ]
              //     )
              //   );
              const result = [];
              const result1 = [];
              //   if (leftArr?.length > 0) {
              // leftArr?.forEach((obj1) => {
              //   let found = false;
              //   paginationState?.rightsideAddedData?.[
              //     paginationState?.rightPageNumber
              //   ]?.forEach((obj2) => {
              //     if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
              //       found = true;
              //     }
              //   });
              //   if (!found) {
              //     result.push(obj1);
              //   }
              // });

              //   leftArr?.forEach((obj1) => {
              //     let found = false;

              //     paginationState?.rightsideAddedData?.[0]?.forEach((obj2) => {
              //       if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
              //         found = true;
              //       }
              //     });

              //     if (!found) {
              //       result1.push(obj1);
              //     }
              //   });

              leftArr?.forEach((obj1) => {
                let found = false;
                Object.keys(paginationState?.rightsideAddedData)?.forEach(
                  (dddata, index) => {
                    // console.log({ dddata });

                    paginationState?.rightsideAddedData?.[dddata]?.forEach(
                      (obj2) => {
                        if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
                          found = true;
                        }
                      }
                    );
                  }
                );

                if (!found) {
                  result1.push(obj1);
                }
              });
              //   }
              //   else {
              //     // res.data?.leftUsers?.content.forEach((obj1) => {
              //     //   let found = false;
              //     //   paginationState?.rightsideAddedData?.[
              //     //     paginationState?.rightPageNumber
              //     //   ]?.forEach((obj2) => {
              //     //     if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
              //     //       found = true;
              //     //     }
              //     //   });
              //     //   if (!found) {
              //     //     result.push(obj1);
              //     //   }
              //     // });

              //     res.data?.leftUsers?.content?.forEach((obj1) => {
              //       let found = false;
              //       Object.keys(paginationState?.rightsideAddedData)?.forEach(
              //         (dddata, index) => {
              //           console.log({ dddata });

              //           paginationState?.rightsideAddedData?.[dddata]?.forEach(
              //             (obj2) => {
              //               if (JSON.stringify(obj1) === JSON.stringify(obj2)) {
              //                 found = true;
              //               }
              //             }
              //           );
              //         }
              //       );

              //       if (!found) {
              //         result1.push(obj1);
              //       }
              //     });
              //   }
              // console.log({ result, result1 });
              leftArr = result1;
              //   setLeft(result);
              // setLeft(
              //   not(
              //     res.data?.leftUsers?.content,
              //     paginationState?.rightsideAddedData?.[
              //       paginationState?.rightPageNumber
              //     ]
              //   )
              // );
            }
            // console.log({ leftArr, rightArr });
            setLeft(leftArr);
            setRight(rightArr);
            setRight1(rightArr);
            setRight2(rightArr);
            if (res.data?.leftUsers?.content) {
              setData1(res.data.leftUsers);
            }
            if (res.data?.righUser?.content) {
              setData2(res.data?.righUser);
            }
          } else {
            if (res.data?.leftUsers?.content) {
              setData1(res.data.leftUsers);
              setLeft(res.data?.leftUsers?.content);
            }
            if (res.data?.righUser?.content) {
              setData2(res.data?.righUser);
              setRight(res.data?.righUser?.content);
              setRight1(res.data?.righUser?.content);
              setRight2(res.data?.righUser?.content);
            }
          }
        } else {
          setHideSkeleton(false);
          // toast.error(res.data.statusdescription.statusDescription, {
          //   toastId: customId1,
          // });
          Swal.fire({
            icon: "error",
            title: "Oops...",
            text: res.data.statusdescription.statusDescription,
            // footer: '<a href="">Why do I have this issue?</a>'
          });
        }
      } catch (error) {
        setHideSkeleton(false);

        // toast.error("Please Check Your Network", {
        //   toastId: customId1,
        // });

        Swal.fire({
          icon: "error",
          title: "Oops...",
          text: "Please Check Your Network",
          // footer: '<a href="">Why do I have this issue?</a>'
        });
      }
    }
  }

  React.useEffect(() => {
    if (pageType == "EditPage" && rightData?.id) {
      ContactGetEdit();
    }
  }, [
    paginationState?.pageNumber,
    paginationState.searchValue,
    paginationState.rightPageNumber,
    paginationState.rightPageSize,
  ]);

  React.useEffect(() => {
    if (
      left?.length == 0 &&
      paginationState.buttonLeftToRight &&
      paginationState.searchValue == "" &&
      pageType != "EditPage" &&
      data1?.totalPages - 1 > paginationState.pageNumber
    ) {
      setPaginationState({
        ...paginationState,
        pageNumber: paginationState.pageNumber + 1,
      });
    }
  }, [left, paginationState.buttonLeftToRight]);

  React.useEffect(() => {
    if (pageType != "EditPage") {
      ContactGet();
    }
  }, [paginationState?.pageNumber, paginationState.searchValue]);

  useEffect(() => {
    if (pageType != "EditPage") {
      onData(right1);
    }
  }, [right1]);

  useEffect(() => {
    if (pageType == "EditPage") {
      let arr = {
        rightsideAddedData: paginationState.rightSideSendData,
        leftsideAddedData: paginationState.leftSideSendData,
      };
      onData(arr);
    }
  }, [paginationState.rightsideAddedData, paginationState.leftsideAddedData]);

  useEffect(() => {
    // console.log("object", rightData, rightData?.length);
    if (rightData && rightData?.id) {
      ContactGetEdit();
    }
  }, [rightData]);

  useEffect(() => {
    if (right2 && right2?.length > 0) {
      if (pageType != "EditPage") {
        ContactGet();
      }
    }
  }, [right2]);

  //   useEffect(() => {
  //     if (pageType == "EditPage" && right?.length > 0) {
  //       if (
  //         paginationState?.rightsideAddedData?.[paginationState?.rightPageNumber]
  //       ) {
  //         alert("now");
  //         console.log(
  //           "PPPPPP",
  //           paginationState?.rightsideAddedData?.[
  //             paginationState?.rightPageNumber
  //           ],
  //           right.concat(
  //             paginationState?.rightsideAddedData?.[
  //               paginationState?.rightPageNumber
  //             ]
  //           )
  //         );
  //         setRight(
  //           right.concat(
  //             paginationState?.rightsideAddedData?.[
  //               paginationState?.rightPageNumber
  //             ]
  //           )
  //         );
  //         setLeft(
  //           not(
  //             left,
  //             paginationState?.rightsideAddedData?.[
  //               paginationState?.rightPageNumber
  //             ]
  //           )
  //         );
  //       }
  //     }
  //   }, [paginationState?.rightPageNumber]);

  const customList = (title, items) => (
    <Card>
      <CardHeader
        sx={{ px: 2, py: 1 }}
        avatar={
          <Checkbox
            onClick={handleToggleAll(items)}
            checked={
              numberOfChecked(items) === items?.length && items?.length !== 0
            }
            indeterminate={
              numberOfChecked(items) !== items?.length &&
              numberOfChecked(items) !== 0
            }
            disabled={items?.length === 0}
            inputProps={{
              "aria-label": "all items selected",
            }}
          />
        }
        title={title}
        subheader={`${numberOfChecked(items)}/${
          items?.length ? items?.length : 0
        } selected`}
      />
      <Divider />
      <div className="user_contact_list " style={{ padding: "16px" }}>
        {title == "User Contact List" ? (
          <div
            className="d-flex align-items-center p-3 py-2"
            style={{ border: "1px solid #ced4da" }}
          >
            {/* <TextField
              className=" w-100"
              style={{
                borderRadius: "4px",
              }}
              type="text"
              label="Search here"
              name="phonebookDescription"
              variant="filled"
              size="small"
              InputProps={{
                startAdornment: (
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                ),
              }}
              value={paginationState?.searchValue}
              onChange={(event) => {
                // onChange(event.target.value);
                setPaginationState({
                  ...paginationState,
                  pageNumber: 0,
                  searchValue: event.target.value,
                });
              }}
            /> */}
            <SearchIcon style={{ width: "1em", height: "1em" }} />

            <input
              type="text"
              placeholder="Search here"
              className="form-control"
              style={{
                width: "100%",
                border: "none",
                padding: "0",
                fontSize: "14px",
                lineHeight: "normal",
              }}
              value={paginationState?.searchValue}
              onChange={(event) => {
                // onChange(event.target.value);
                setPaginationState({
                  ...paginationState,
                  pageNumber: 0,
                  searchValue: event.target.value,
                });
              }}
            />
          </div>
        ) : (
          <div
            className="d-flex align-items-center p-3 py-2"
            style={{ border: "1px solid #ced4da" }}
          >
            {/* <TextField
                className=" w-100"
                style={{
                  borderRadius: "4px",
                }}
                type="text"
                label="Search here"
                name="phonebookDescription"
                variant="filled"
                size="small"
                InputProps={{
                  startAdornment: (
                    <InputAdornment position="start">
                      <SearchIcon />
                    </InputAdornment>
                  ),
                }}
                value={paginationState?.searchValue1}
                onChange={(event) => {
                  setPaginationState({
                    ...paginationState,
                    searchValue1: event.target.value,
                    rightPageNumber: 0,
                  });
                  const data = right1.filter((dddd, index) =>
                    dddd.contactName
                      .toLowerCase()
                      .includes(event.target.value.toLowerCase())
                  );
                  console.log({ data, right1 });
                  setRight(data);
                }}
              /> */}

            <SearchIcon style={{ width: "1em", height: "1em" }} />
            {pageType == "EditPage" ? (
              <input
                type="text"
                placeholder="Search here"
                className="form-control"
                style={{
                  width: "100%",
                  border: "none",
                  padding: "0",
                  fontSize: "14px",
                  lineHeight: "normal",
                }}
                value={paginationState?.searchValue}
                onChange={(event) => {
                  // onChange(event.target.value);
                  setPaginationState({
                    ...paginationState,
                    pageNumber: 0,
                    rightPageNumber: 0,
                    searchValue: event.target.value,
                  });
                }}
              />
            ) : (
              <input
                type="text"
                placeholder="Search here"
                className="form-control"
                style={{
                  width: "100%",
                  border: "none",
                  padding: "0",
                  fontSize: "14px",
                  lineHeight: "normal",
                }}
                value={paginationState?.searchValue1}
                onChange={(event) => {
                  setPaginationState({
                    ...paginationState,
                    searchValue1: event.target.value,
                    rightPageNumber: 0,
                  });
                  const data = right1.filter((dddd, index) =>
                    dddd.contactName
                      .toLowerCase()
                      .includes(event.target.value.toLowerCase())
                  );
                  // console.log({ data, right1 });
                  setRight(data);
                }}
              />
            )}
          </div>
        )}
      </div>
      <Divider />
      {hideSkeleton &&
      (title == "User Contact List" || pageType == "EditPage") ? (
        <>
          <Skeleton animation="wave" sx={{ width: width }} className="mt-3" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
          <Skeleton animation="wave" />
        </>
      ) : (
        <>
          <List
            sx={{
              width: width,
              height: height,
              bgcolor: "background.paper",
              overflow: "auto",
            }}
            dense
            component="div"
            role="list"
          >
            {items?.length == 0 ? (
              <div className="text-center m-5 pt-5">
                <svg
                  className="ant-empty-img-simple"
                  width="64"
                  height="41"
                  viewBox="0 0 64 41"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <g transform="translate(0 1)" fill="none" fill-rule="evenodd">
                    <ellipse
                      className="ant-empty-img-simple-ellipse"
                      cx="32"
                      cy="33"
                      rx="32"
                      ry="7"
                    ></ellipse>
                    <g className="ant-empty-img-simple-g" fill-rule="nonzero">
                      <path d="M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"></path>
                      <path
                        d="M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z"
                        className="ant-empty-img-simple-path"
                      ></path>
                    </g>
                  </g>
                </svg>
                <h5>No Data</h5>
                {title == "User Contact List" &&
                paginationState?.searchValue == "" &&
                paginationState.pageNumber + 1 < data1?.totalPages ? (
                  <button
                    className="ant-btn ant-btn-primary ant-btn-sm"
                    onClick={() => {
                      setPaginationState({
                        ...paginationState,
                        pageNumber: paginationState.pageNumber + 1,
                      });
                    }}
                  >
                    Go to Next Page
                  </button>
                ) : null}
              </div>
            ) : (
              <>
                {items &&
                  items?.map((value, index) => {
                    const labelId = `transfer-list-all-item-${value?.id}-${index}-label`;
                    if (
                      paginationState?.rightPageStartIndex <= index &&
                      paginationState?.rightPageEndIndex > index &&
                      title != "User Contact List" &&
                      pageType != "EditPage"
                    ) {
                      return (
                        <ListItem
                          key={labelId}
                          role="listitem"
                          button
                          onClick={handleToggle(value)}
                        >
                          <ListItemIcon>
                            <Checkbox
                              checked={checked.indexOf(value) !== -1}
                              tabIndex={-1}
                              disableRipple
                              inputProps={{
                                "aria-labelledby": labelId,
                              }}
                            />
                          </ListItemIcon>
                          <ListItemText
                            id={labelId}
                            primary={value?.contactName}
                          />
                        </ListItem>
                      );
                    } else if (
                      title != "User Contact List" &&
                      pageType == "EditPage"
                    ) {
                      return (
                        <ListItem
                          key={labelId}
                          role="listitem"
                          button
                          onClick={handleToggle(value)}
                        >
                          <ListItemIcon>
                            <Checkbox
                              checked={checked.indexOf(value) !== -1}
                              tabIndex={-1}
                              disableRipple
                              inputProps={{
                                "aria-labelledby": labelId,
                              }}
                            />
                          </ListItemIcon>
                          <ListItemText
                            id={labelId}
                            primary={value?.contactName}
                          />
                        </ListItem>
                      );
                    } else if (title == "User Contact List") {
                      return (
                        <ListItem
                          key={labelId}
                          role="listitem"
                          button
                          onClick={handleToggle(value)}
                        >
                          <ListItemIcon>
                            <Checkbox
                              checked={checked.indexOf(value) !== -1}
                              tabIndex={-1}
                              disableRipple
                              inputProps={{
                                "aria-labelledby": labelId,
                              }}
                            />
                          </ListItemIcon>
                          <ListItemText
                            id={labelId}
                            className="ant-transfer-list-content-item-text"
                            primary={value?.contactName}
                          />
                        </ListItem>
                      );
                    }

                    //       return (
                    //         <>
                    //           {index == 0 ? (
                    //     <div className="row">
                    //       <div>
                    //         <TextField
                    //           className=" w-100"
                    //           style={{
                    //             borderRadius: "4px",
                    //           }}
                    //           type="text"
                    //           label="Search"
                    //           name="phonebookDescription"
                    //           variant="outlined"
                    //           size="small"
                    //           // required

                    //           //   value={description}
                    //           //   onChange={(event) => {
                    //           //     setdescription(event.target.value);
                    //           //   }}
                    //         />
                    //       </div>
                    //     </div>
                    //   ) : null}
                    //         </>
                    //       );
                  })}
              </>
            )}
          </List>
        </>
      )}
      <Divider />
      <div className="row justify-content-end my-2">
        <div className="col-md-6">
          {title == "User Contact List" ? (
            <>
              {data1?.totalPages ? (
                <div className="ms-3">
                  {/* {width > 300 ? <span className="me-2">page:</span> : null} */}
                  <input
                    type="number"
                    name=""
                    style={{
                      textAlign: "center",
                      padding: "0 6px",
                      marginLeft: "8px",
                      width: "50px",
                    }}
                    id=""
                    onChange={(e) => {
                      if (
                        e.target.value > 0 &&
                        e.target.value < data1?.totalPages + 1
                      ) {
                        const pageNumber = e.target.value
                          ? Number(e.target.value) - 1
                          : 0;
                        setPaginationState({
                          ...paginationState,
                          pageNumber,
                        });
                      }
                    }}
                    value={paginationState?.pageNumber + 1}
                    // style={{ width: "50px" }}
                  />{" "}
                  <span class="ant-pagination-slash">/</span>{" "}
                  {data1?.totalPages}
                </div>
              ) : (
                <br></br>
              )}
            </>
          ) : (
            <>
              {title != "User Contact List" && pageType == "EditPage" ? (
                <>
                  {data2?.totalPages ? (
                    <div className="ms-3">
                      {/* {width > 300 ? <span className="me-2">page:</span> : null} */}
                      <input
                        type="number"
                        name=""
                        id=""
                        style={{
                          textAlign: "center",
                          padding: "0 6px",
                          marginLeft: "8px",
                          width: "50px",
                        }}
                        onChange={(e) => {
                          if (
                            e.target.value > 0 &&
                            e.target.value < data2?.totalPages + 1
                          ) {
                            const pageNumber = e.target.value
                              ? Number(e.target.value) - 1
                              : 0;
                            setPaginationState({
                              ...paginationState,
                              rightPageNumber: pageNumber,
                            });
                          }
                        }}
                        value={paginationState?.rightPageNumber + 1}
                      />{" "}
                      / {data2?.totalPages}
                    </div>
                  ) : (
                    <br></br>
                  )}
                </>
              ) : (
                <>
                  {right1?.length > 0 ? (
                    <div className="ms-3">
                      {/* {width > 300 ? <span className="me-2">page:</span> : null} */}
                      <input
                        type="number"
                        name=""
                        id=""
                        style={{
                          textAlign: "center",
                          padding: "0 6px",
                          marginLeft: "8px",
                          width: "50px",
                        }}
                        onChange={(e) => {
                          if (
                            e.target.value > 0 &&
                            e.target.value < Math.ceil(right1?.length / 10) + 1
                          ) {
                            const pageNumber = e.target.value
                              ? Number(e.target.value) - 1
                              : 0;
                            // console.log(
                            //   "here",
                            //   (pageNumber + 1) * paginationState.rightPageSize -
                            //     10,

                            //   (pageNumber + 1) * paginationState.rightPageSize
                            // );
                            setPaginationState({
                              ...paginationState,
                              rightPageNumber: pageNumber,
                              rightPageStartIndex:
                                (pageNumber + 1) *
                                  paginationState.rightPageSize -
                                10,
                              rightPageEndIndex:
                                (pageNumber + 1) *
                                paginationState.rightPageSize,
                            });
                          }
                        }}
                        value={paginationState?.rightPageNumber + 1}
                      />{" "}
                      / {Math.ceil(right1?.length / 10)}
                    </div>
                  ) : (
                    <br></br>
                  )}
                </>
              )}
              {/* {right1?.length > 0 ? (
                <div className="ms-3">
                 
                  <input
                    type="number"
                    name=""
                    id=""
                    style={{
                      textAlign: "center",
                      padding: "0 6px",
                      marginLeft: "8px",
                      width: "50px",
                    }}
                    onChange={(e) => {
                      if (
                        e.target.value > 0 &&
                        e.target.value < Math.ceil(right1?.length / 10) + 1
                      ) {
                        const pageNumber = e.target.value
                          ? Number(e.target.value) - 1
                          : 0;
                        console.log(
                          "here",
                          (pageNumber + 1) * paginationState.rightPageSize - 10,

                          (pageNumber + 1) * paginationState.rightPageSize
                        );
                        setPaginationState({
                          ...paginationState,
                          rightPageNumber: pageNumber,
                          rightPageStartIndex:
                            (pageNumber + 1) * paginationState.rightPageSize -
                            10,
                          rightPageEndIndex:
                            (pageNumber + 1) * paginationState.rightPageSize,
                        });
                      }
                    }}
                    value={paginationState?.rightPageNumber + 1}
                  />{" "}
                  / {Math.ceil(right1?.length / 10)}
                </div>
              ) : null} */}
            </>
          )}
        </div>
        {/* <div className="col-md-6">
          <div className="text-end">
            <button>Prev</button>
            <button>Next</button>
          </div>
        </div> */}
      </div>
    </Card>
  );

  useEffect(() => {
    if (reloadReducer != "") {
      if (pageType == "EditPage") {
        ResetStates();
        // ContactGetEdit();
      } else {
        ContactGet();
        setRight([]);
        setRight1([]);
      }
    }
  }, [reloadReducer]);

  return (
    <>
      {/* <button id="phoneBoookResetButtonId" onClick={ResetStates}>
        Reset
      </button> */}
      <Grid
        container
        spacing={2}
        justifyContent="center"
        alignItems="center"
        sx={{ padding: 0 }}
      >
        <Grid item>{customList("User Contact List", left)}</Grid>
        <Grid item>
          <div class="ant-transfer-operation">
            <button
              type="button"
              onClick={handleCheckedRight}
              disabled={leftChecked.length === 0}
              class="ant-btn green_UP text-white ant-btn-sm"
            >
              <span role="img" aria-label="right" class="anticon anticon-right">
                <svg
                  viewBox="64 64 896 896"
                  focusable="false"
                  data-icon="right"
                  width="1em"
                  height="1em"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path d="M765.7 486.8L314.9 134.7A7.97 7.97 0 00302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 000-50.4z"></path>
                </svg>
              </span>
              <span className="">Add</span>
            </button>
            <button
              type="button"
              disabled={rightChecked.length === 0}
              onClick={handleCheckedLeft}
              class="ant-btn failClr text-white ant-btn-sm"
            >
              <span role="img" aria-label="left" class="anticon anticon-left">
                <svg
                  viewBox="64 64 896 896"
                  focusable="false"
                  data-icon="left"
                  width="1em"
                  height="1em"
                  fill="currentColor"
                  aria-hidden="true"
                >
                  <path d="M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 000 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z"></path>
                </svg>
              </span>
              <span className="">Remove</span>
            </button>
          </div>
          {/* <Grid container direction="column" alignItems="center">
            <Button
              sx={{ my: 0.5 }}
              variant="contained"
              size="small"
              onClick={handleCheckedRight}
              disabled={leftChecked.length === 0}
              aria-label="move selected right"
            >
              &gt; Add
            </Button>
            <Button
              sx={{ my: 0.5 }}
              variant="contained"
              size="small"
              onClick={handleCheckedLeft}
              disabled={rightChecked.length === 0}
              aria-label="move selected left"
            >
              &lt; Remove
            </Button>
            <button
            disabled={leftChecked.length === 0}
            onClick={handleCheckedRight}
            className="ant-btn ant-btn-primary ant-btn-sm mb-2"
          >
            {">"} Add {"  "}
          </button>
          <button
            disabled={rightChecked.length === 0}
            onClick={handleCheckedLeft}
            className="ant-btn ant-btn-primary ant-btn-sm"
          >
            {"<"} Remove
          </button>
          </Grid> */}
        </Grid>
        <Grid item>{customList("Add Contact In Phonebook", right)}</Grid>
      </Grid>
    </>
  );
}

export default memo(TransferListTest);




